import { useState, useEffect, useCallback } from "react";
import { Doughnut, Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler,
} from "chart.js";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  AppBar, Toolbar, Box, Typography, IconButton, Avatar, Badge,
  Card, CardContent, CardHeader, Grid, Chip,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  LinearProgress, Paper, TextField, InputAdornment, Dialog,
  DialogTitle, DialogContent, Divider, Stack,
  createTheme, ThemeProvider, CssBaseline, alpha,
  CircularProgress,
  Tooltip,
  Skeleton,
  Button,
} from "@mui/material";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import SettingsVoiceIcon from '@mui/icons-material/SettingsVoice';
import {  ShowChart as Activity,
  NotificationsOutlined as Bell,
  SearchOutlined as Search,
  ChevronLeft,
  ChevronRight,
  CheckBoxOutlined as CheckSquare,
  AccessTimeOutlined as Clock,
  CheckCircleOutlined as CheckCircle,
  WorkOutlineOutlined as Briefcase,
  CloseOutlined as CloseIcon,
  InfoOutlined as Info,
  GroupOutlined as GroupIcon,
  AssignmentOutlined as AssignmentIcon,
} from "@mui/icons-material";
// import { dispatch } from "d3";
import { useDispatch, useSelector } from "react-redux";
import { DashcalpostData, EmergencyNotificationGet, EmergencyNotificationPost, ProjectManagerDashboard } from "../../store/reducers/Formapireducer";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { CalendarToday } from "@mui/icons-material";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import { dashBoardAtten, fetchApidata } from "../../store/reducers/LoginReducer";
import { CheckinAutocomplete, CheckinAutocompleteDash, Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import Datavisual1 from "./Calendar";
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import toast from "react-hot-toast";
import { FaCommentsDollar } from "react-icons/fa";
import { styled } from "@mui/material/styles";
import EventCalender from "./EventCalendar";
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import Swal from "sweetalert2";
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { getConfig } from "../../config";

ChartJS.register(
  ArcElement, ChartTooltip, Legend,
  CategoryScale, LinearScale, BarElement,
  LineElement, PointElement, Filler
);


const CustomIconButton = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: 10,
  border: "1px solid rgba(0,0,0,0.07)",
  // background: theme.palette.background.paper,
  // color: theme.palette.primary.main,
  background: "#f4f6fb",
  color: "#06b6d4",
  transition: "all 0.18s ease",
  padding: "2px",

  "&:hover": {
    background: "#f1f5f9",
  },
}));
// ─── THEME ───────────────────────────────────────────────────────
function buildTheme(dark) {
  return createTheme({
    palette: {
      mode: dark ? "dark" : "light",
      primary: { main: "#1d4ed8" },
      success: { main: "#059669" },
      warning: { main: "#d97706" },
      error: { main: "#dc2626" },
      background: {
        default: dark ? "#0d0f14" : "#ffffff",
        paper: dark ? "#161b27" : "#ffffff",
      },
    },
    // typography: { fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
    typography: { fontFamily: "'Outfit',sans-serif", fontSize: 13 },
    shape: { borderRadius: 12 },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: dark
              ? "0 1px 3px rgba(0,0,0,.3)"
              : "0 1px 3px rgba(0,0,0,.06),0 1px 2px rgba(0,0,0,.04)",
            border: dark ? "none" : "1px solid rgba(0,0,0,0.08)",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: { fontSize: 10, fontWeight: 600, letterSpacing: 0.6 },
          body: { fontSize: 12 },
        },
      },
      MuiChip: { styleOverrides: { label: { fontSize: 10, fontWeight: 600 } } },
      MuiInputBase: { styleOverrides: { input: { fontSize: 12 } } },
    },
  });
}

// ─── API / MOCK ───────────────────────────────────────────────────
// const API_URL = "/dashboard_api_v2.php";
// const EMPLOYEE_ID = 1;

// async function fetchDashboard() {
//   const res = await fetch(API_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ EmployeeID: EMPLOYEE_ID }),
//   });
//   return res.json();
// }

const MOCK = {
  taskSummaryCardData: [
    {
      title: "Backlog Tasks", count: 3, gradient: "linear-gradient(135deg,#f77062,#fe5196)",
      breakdown: [{ label: "Self", value: 0 }, { label: "Manager", value: 3 }, { label: "Sprint", value: 0 }],
      kpiProjects: [{ id: "P002", name: "LGEMS", color: "#ef4444", count: 2 }, { id: "P029", name: "ATM v2", color: "#f77062", count: 1 }]
    },
    {
      title: "To Do Tasks", count: 29, gradient: "linear-gradient(135deg,#0ea5e9,#38bdf8)",
      breakdown: [{ label: "Self", value: 22 }, { label: "Manager", value: 7 }, { label: "Sprint", value: 0 }],
      kpiProjects: [{ id: "P001", name: "Agile Task Mgmt", color: "#1d4ed8", count: 12 }, { id: "P021", name: "Telliant", color: "#10b981", count: 9 }]
    },
    {
      title: "Completed Tasks", count: 329, gradient: "linear-gradient(135deg,#10b981,#34d399)",
      breakdown: [{ label: "Self", value: 308 }, { label: "Manager", value: 19 }, { label: "Sprint", value: 2 }],
      kpiProjects: [{ id: "P001", name: "Agile Task Mgmt", color: "#1d4ed8", count: 148 }, { id: "P021", name: "Telliant", color: "#10b981", count: 62 }]
    },
    {
      title: "Total Tasks", count: 361, gradient: "linear-gradient(135deg,#f59e0b,#fbbf24)",
      breakdown: [{ label: "Spot Activity", value: 18 }, { label: "Approved", value: 240 }, { label: "Blocked", value: 5 }],
      kpiProjects: [{ id: "P001", name: "Agile Task Mgmt", color: "#1d4ed8", count: 162 }, { id: "P002", name: "LGEMS", color: "#ef4444", count: 62 }]
    },
  ],
  statusDistribution: [
    { label: "Completed", value: 329, color: "#10b981" }, { label: "In Progress", value: 45, color: "#3b6ef8" },
    { label: "To Do", value: 29, color: "#f59e0b" }, { label: "Backlog", value: 3, color: "#ef4444" },
  ],
  projectEffortData: {
    labels: ["P001", "P021", "P029"], projects: ["Agile Task Mgmt", "Telliant Systems", "ATM v2"],
    estimated: [5500, 1800, 800], actual: [4900, 1500, 700],
    drilldown: {
      "P001": { est: 5500, act: 4900, employees: [{ name: "Radhika", est: 2200, act: 2000 }, { name: "Parkavi", est: 1500, act: 1400 }, { name: "Nithish.T", est: 1000, act: 850 }] },
      "P021": { est: 1800, act: 1500, employees: [{ name: "Parkavi", est: 800, act: 700 }, { name: "Manikandan", est: 600, act: 500 }] },
      "P029": { est: 800, act: 700, employees: [{ name: "Radhika", est: 400, act: 380 }, { name: "Nithish.T", est: 250, act: 200 }] },
    },
  },
  projectList: [
    { id: "P001", name: "Agile Task Management", status: "active", prog: 82, tasks: 148 },
    { id: "P002", name: "LGEMS", status: "risk", prog: 55, tasks: 89 },
    { id: "P021", name: "Telliant Systems", status: "active", prog: 68, tasks: 79 },
    { id: "P029", name: "ATM v2", status: "overdue", prog: 30, tasks: 44 },
    { id: "P0011", name: "Pre-School Academic Year", status: "active", prog: 72, tasks: 62 },
    { id: "P0012", name: "Employee Task Mgmt App", status: "active", prog: 90, tasks: 110 },
  ],
  personnelList: [
    { init: "MV", name: "Manikandan.V", id: "T0149", hrs: 9, util: 12, cost: "₹2,008" },
    { init: "PA", name: "Parkavi", id: "T0121", hrs: 21, util: 8, cost: "₹4,688" },
    { init: "RA", name: "Radhika", id: "T0134", hrs: 39, util: 5, cost: "₹8,705" },
    { init: "SS", name: "Sathish.S", id: "T0111", hrs: 3, util: 20, cost: "₹669" },
    { init: "NT", name: "Nithish.T", id: "T0126", hrs: 6, util: 15, cost: "₹1,339" },
  ],
  empTasksMap: {
    "T0149": [{ code: "TSK-1041", name: "UI Layout - Dashboard", project: "P021", est: 3, act: 3.5, status: "C", date: "2026-03-10" }, { code: "TSK-1042", name: "API Integration - Auth", project: "P021", est: 2, act: 1.8, status: "C", date: "2026-03-11" }, { code: "TSK-1048", name: "Bug Fix - Login Page", project: "P001", est: 2, act: 2.5, status: "I", date: "2026-03-14" }, { code: "TSK-1055", name: "Unit Testing Module A", project: "P001", est: 2, act: 1.2, status: "AP", date: "2026-03-16" }],
    "T0121": [{ code: "TSK-2011", name: "Requirement Analysis", project: "P021", est: 4, act: 5, status: "C", date: "2026-03-05" }, { code: "TSK-2015", name: "DB Schema Design", project: "P021", est: 3, act: 3, status: "C", date: "2026-03-08" }, { code: "TSK-2021", name: "REST API - Reports", project: "P021", est: 5, act: 6.5, status: "I", date: "2026-03-12" }, { code: "TSK-2028", name: "Frontend Components", project: "P001", est: 4, act: 3.5, status: "AS", date: "2026-03-15" }],
    "T0134": [{ code: "TSK-3002", name: "Sprint Planning", project: "P001", est: 2, act: 2, status: "C", date: "2026-02-28" }, { code: "TSK-3008", name: "Module - Employee CRUD", project: "P001", est: 6, act: 7.5, status: "C", date: "2026-03-04" }, { code: "TSK-3014", name: "Report Generation", project: "P001", est: 5, act: 4.8, status: "C", date: "2026-03-09" }, { code: "TSK-3037", name: "QA Sign-off", project: "P001", est: 3, act: 2, status: "I", date: "2026-03-18" }],
    "T0111": [{ code: "TSK-4005", name: "Database Optimization", project: "P021", est: 2, act: 1.5, status: "C", date: "2026-03-10" }, { code: "TSK-4011", name: "Index Tuning", project: "P021", est: 1, act: 1.5, status: "AP", date: "2026-03-15" }],
    "T0126": [{ code: "TSK-5003", name: "UI Component Library", project: "P0011", est: 3, act: 2.5, status: "C", date: "2026-03-08" }, { code: "TSK-5009", name: "Theme Integration", project: "P0011", est: 2, act: 2, status: "C", date: "2026-03-12" }, { code: "TSK-5015", name: "Mobile Responsive Fix", project: "P0012", est: 1, act: 1.5, status: "I", date: "2026-03-17" }],
  },
  taskTrend: {
    labels: ["W7 Jan", "W3 Feb", "W1 Mar", "W2 Mar", "W3 Mar", "W4 Mar", "W1 Apr", "W2 Apr"],
    actual: [28, 34, 38, 41, 45, 48, 52, 57], target: [30, 35, 40, 43, 46, 50, 54, 58],
  },
  milestoneTimeline: [
    { id: "P001", name: "Agile Task Mgmt", color: "#3b6ef8", start: "2026-01-05", end: "2026-05-20", milestones: [{ date: "2026-02-10", label: "Alpha Release", done: true }, { date: "2026-03-28", label: "Beta Launch", done: false }, { date: "2026-05-20", label: "Go Live", done: false }] },
    { id: "P002", name: "LGEMS", color: "#f59e0b", start: "2026-01-15", end: "2026-06-10", milestones: [{ date: "2026-02-28", label: "Req Sign-off", done: true }, { date: "2026-04-15", label: "UAT Start", done: false }, { date: "2026-06-10", label: "Delivery", done: false }] },
    { id: "P021", name: "Telliant Systems", color: "#10b981", start: "2026-02-01", end: "2026-06-20", milestones: [{ date: "2026-03-15", label: "Design Freeze", done: true }, { date: "2026-04-30", label: "Sprint 5 End", done: false }, { date: "2026-06-20", label: "Launch", done: false }] },
    { id: "P029", name: "ATM v2", color: "#ef4444", start: "2026-01-10", end: "2026-04-15", milestones: [{ date: "2026-02-05", label: "Kickoff Done", done: true }, { date: "2026-03-10", label: "Code Freeze", done: true }, { date: "2026-04-15", label: "Release ⚠️", done: false }] },
    { id: "P0011", name: "Pre-School AY", color: "#a855f7", start: "2026-02-15", end: "2026-05-30", milestones: [{ date: "2026-03-20", label: "Prototype", done: true }, { date: "2026-05-01", label: "UAT", done: false }, { date: "2026-05-30", label: "Go-Live", done: false }] },
    { id: "P0012", name: "Emp Task Mgmt", color: "#06b6d4", start: "2026-01-20", end: "2026-04-30", milestones: [{ date: "2026-02-20", label: "MVP Done", done: true }, { date: "2026-03-25", label: "Beta Release", done: true }, { date: "2026-04-30", label: "Production", done: false }] },
  ],
  actionItems: [
    { bar: "#ef4444", dot: "#ef4444", title: "ATM v2 — 4 days overdue", meta: "P029 · Updated 2h ago", tag: "Overdue", tagColor: "error" },
    { bar: "#f59e0b", dot: "#f59e0b", title: "T0121 Parkavi — Overloaded", meta: "Workload · P021 Telliant", tag: "At Risk", tagColor: "warning" },
    { bar: "#3b82f6", dot: "#3b82f6", title: "LGEMS — Budget Review Due", meta: "P002 · Finance", tag: "Review", tagColor: "primary" },
  ],

  projectEmployeeMap: {
    "P001": [
      {
        init: "RA", name: "Radhika", id: "T0134", hrs: 14, util: 9, cost: "₹3,122",
        tasks: [
          { code: "TSK-3002", name: "Sprint Planning", est: 2, act: 2, status: "C", date: "2026-02-28" },
          { code: "TSK-3008", name: "Module - Employee CRUD", est: 6, act: 7.5, status: "C", date: "2026-03-04" },
          { code: "TSK-3014", name: "Report Generation", est: 5, act: 4.8, status: "C", date: "2026-03-09" },
          { code: "TSK-3037", name: "QA Sign-off", est: 3, act: 2, status: "I", date: "2026-03-18" },
        ]
      },
      {
        init: "PA", name: "Parkavi", id: "T0121", hrs: 4, util: 3, cost: "₹892",
        tasks: [
          { code: "TSK-2028", name: "Frontend Components", est: 4, act: 3.5, status: "AS", date: "2026-03-15" },
        ]
      },
      {
        init: "MV", name: "Manikandan.V", id: "T0149", hrs: 4.5, util: 3, cost: "₹1,003",
        tasks: [
          { code: "TSK-1048", name: "Bug Fix - Login Page", est: 2, act: 2.5, status: "I", date: "2026-03-14" },
          { code: "TSK-1055", name: "Unit Testing Module A", est: 2, act: 1.2, status: "AP", date: "2026-03-16" },
        ]
      },
    ],
    "P002": [
      {
        init: "RA", name: "Radhika", id: "T0134", hrs: 8, util: 5, cost: "₹1,784",
        tasks: [
          { code: "TSK-3020", name: "LGEMS DB Schema", est: 4, act: 4.5, status: "C", date: "2026-02-20" },
          { code: "TSK-3025", name: "API - Reports Module", est: 4, act: 3.5, status: "I", date: "2026-03-05" },
        ]
      },
    ],
    "P021": [
      {
        init: "PA", name: "Parkavi", id: "T0121", hrs: 17, util: 11, cost: "₹3,796",
        tasks: [
          { code: "TSK-2011", name: "Requirement Analysis", est: 4, act: 5, status: "C", date: "2026-03-05" },
          { code: "TSK-2015", name: "DB Schema Design", est: 3, act: 3, status: "C", date: "2026-03-08" },
          { code: "TSK-2021", name: "REST API - Reports", est: 5, act: 6.5, status: "I", date: "2026-03-12" },
        ]
      },
      {
        init: "MV", name: "Manikandan.V", id: "T0149", hrs: 5, util: 3, cost: "₹1,116",
        tasks: [
          { code: "TSK-1041", name: "UI Layout - Dashboard", est: 3, act: 3.5, status: "C", date: "2026-03-10" },
          { code: "TSK-1042", name: "API Integration - Auth", est: 2, act: 1.8, status: "C", date: "2026-03-11" },
        ]
      },
      {
        init: "SS", name: "Sathish.S", id: "T0111", hrs: 3, util: 2, cost: "₹669",
        tasks: [
          { code: "TSK-4005", name: "Database Optimization", est: 2, act: 1.5, status: "C", date: "2026-03-10" },
          { code: "TSK-4011", name: "Index Tuning", est: 1, act: 1.5, status: "AP", date: "2026-03-15" },
        ]
      },
    ],
    "P029": [
      {
        init: "RA", name: "Radhika", id: "T0134", hrs: 7, util: 4, cost: "₹1,561",
        tasks: [
          { code: "TSK-3040", name: "ATM Core Module", est: 4, act: 4.5, status: "C", date: "2026-02-15" },
          { code: "TSK-3041", name: "Payment Gateway", est: 3, act: 2.5, status: "I", date: "2026-03-01" },
        ]
      },
      {
        init: "NT", name: "Nithish.T", id: "T0126", hrs: 4.5, util: 3, cost: "₹1,004",
        tasks: [
          { code: "TSK-5010", name: "ATM UI Screens", est: 3, act: 2.5, status: "C", date: "2026-02-28" },
          { code: "TSK-5011", name: "Receipt Template", est: 1, act: 1.5, status: "I", date: "2026-03-10" },
        ]
      },
    ],
    "P0011": [
      {
        init: "NT", name: "Nithish.T", id: "T0126", hrs: 5, util: 3, cost: "₹1,116",
        tasks: [
          { code: "TSK-5003", name: "UI Component Library", est: 3, act: 2.5, status: "C", date: "2026-03-08" },
          { code: "TSK-5009", name: "Theme Integration", est: 2, act: 2, status: "C", date: "2026-03-12" },
        ]
      },
    ],
    "P0012": [
      {
        init: "NT", name: "Nithish.T", id: "T0126", hrs: 1.5, util: 1, cost: "₹334",
        tasks: [
          { code: "TSK-5015", name: "Mobile Responsive Fix", est: 1, act: 1.5, status: "I", date: "2026-03-17" },
        ]
      },
    ],
  },
};

// ─── CONSTANTS ────────────────────────────────────────────────────
// const AVATAR_COLORS = ["#3b6ef8", "#ef4444", "#10b981", "#f59e0b", "#a855f7", "#06b6d4"];
const AVATAR_COLORS = ["#1d4ed8", "#dc2626", "#059669", "#d97706", "#7c3aed", "#0e7490", "#94a3b8"];
const completedColor = "#059669";
const toDoColor = "#1d4ed8";
const backLogColor = "#dc2626";
const approvedColor = "#7c3aed";
const blockedColor = "#d97706";
const rejectedColor = "#94a3b8";
const transferredColor = "#0e7490";
const DEFAULT_COLORS = {
  completed: "#059669",
  toDo: "#1d4ed8",
  backLog: "#dc2626",
  approved: "#7c3aed",
  blocked: "#d97706",
  rejected: "#94a3b8",
  transferred: "#0e7490",
  totalTask: "#cc6699",
};
const STATUS_META = {
  C: { label: "Completed", color: "success" },
  I: { label: "In Progress", color: "primary" },
  AP: { label: "Approved", color: "secondary" },
  AS: { label: "Assigned", color: "warning" },
  RJ: { label: "Rejected", color: "error" },
};
const PROJ_STATUS = { active: { label: "Active", color: "success" }, Inactive: { label: "Inactive", color: "warning" }, risk: { label: "At Risk", color: "warning" }, overdue: { label: "Overdue", color: "error" } };
const PROJ_BAR_COLOR = { active: "success", Inactive: "warning", risk: "warning", overdue: "error" };

// Shared fixed height for both chart CardContent areas — makes them identical
const CHART_CONTENT_HEIGHT = 300;

// ─── MILESTONE HELPERS ────────────────────────────────────────────
const TL_START = new Date("2026-01-01");
const TL_END = new Date("2026-06-30");
const TL_DAYS = (TL_END - TL_START) / 86400000;
const tlPct = d => Math.max(0, Math.min(100, ((new Date(d) - TL_START) / 86400000 / TL_DAYS) * 100));

const chartColors = (dark) => ({
  gridC: dark ? "rgba(255,255,255,.05)" : "rgba(0,0,0,.05)",
  tickC: dark ? "#525b70" : "#9aa0b0",
  // tf: { family: "DM Sans", size: 10 },
  tf: { family: "Outfit", size: 10 },
});


// ─── TOPBAR ───────────────────────────────────────────────────────
function Topbar({ isCalendar, setIsCalendar, isEventCalendar, setIsEventCalendar, emergencyData }) {
  const date = new Date().toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
  const companyClassification = sessionStorage.getItem("Classification");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const is002Subscription = SubscriptionCode.endsWith("002");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");
  const MultipleChildren = sessionStorage.getItem("MultipleChildren");
  const EmpMailID = sessionStorage.getItem("EmpMailID");
  const EmpMobileNo = sessionStorage.getItem("EmpMobileNo");
  console.log(MultipleChildren, EmpMailID, EmpMobileNo, "--MultipleChildren in sessionstorage");

  // const [isCalender, setIsCalender] = useState(false);
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };
  const empID = sessionStorage.getItem("EmpId");
  const EmpName = sessionStorage.getItem("EmpName");
  const compID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const [refreshKey, setRefreshKey] = useState(0);
  const [childName, setChildName] = useState(null);
  const today = new Date().toISOString().split("T")[0];

  const [notificationOpen, setNotificationOpen] =
    useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);


    const config = getConfig();
    const baseurl1 = config.BASE_URL;
    console.log(baseurl1, "url path");

      const baseurlBOS = config.BOS_URL;
    


  // const handleReadNotification =
  //   async (compID, empID,todayDate, RecordID) => {
  //     const response = await dispatch(EmergencyNotificationPost({ CompanyID: compID, EmployeeID: empID, RecordID: RecordID }));
  //     const res = response.payload; 
  //     if (res.Status === "Y") {
  //       toast.success(res.Msg || res.Message);
  //       setNotificationOpen(true);
  //       dispatch(EmergencyNotificationGet({ CompanyID: compID, EmployeeID: empID, EventDate:todayDate }));
  //     } else {
  //       toast.error(res.Msg || res.Message);
  //   };
  // }

  const handleReadNotification = async (
    compID,
    empID,
    todayDate,
    RecordID,
    IsRead
  ) => {
    const response = await dispatch(
      EmergencyNotificationPost({
        CompanyID: compID,
        EmployeeID: empID,
        RecordID,
        IsRead,
      })
    );

    const res = response.payload;

    if (res.Status === "Y") {
      toast.success(res.Msg || res.Message);

      dispatch(
        EmergencyNotificationGet({
          CompanyID: compID,
          EmployeeID: empID,
          EventDate: todayDate,
        })
      );

      setSelectedNotification(null);
    } else {
      toast.error(res.Msg || res.Message);
    }
  };


    

  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: "background.paper", borderBottom: "1px solid", borderColor: "divider", color: "text.primary", zIndex: 1000, }}>

      <Dialog
        open={notificationOpen}
        onClose={() => setNotificationOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            maxHeight: "70vh",
            borderRadius: 2,
          }
        }}
      >
        <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  bgcolor: "error.main",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 17,
                  color: "#fff",
                  flexShrink: 0,
                }}
              >
                {emergencyData.NotificationCount || 0}
              </Box>
              <Box>
                <Typography variant="subtitle1" fontWeight={600} lineHeight={1.2}>
                  Emergency Notifications
                </Typography>
              </Box>
            </Box>
            <IconButton size="small" onClick={() => setNotificationOpen(false)}>
              <CloseOutlined fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              height: "60vh",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: selectedNotification ? "60%" : "100%",
                borderRight: "1px solid",
                borderColor: "divider",
                overflowY: "auto",
              }}
            >
              {emergencyData?.Notifications?.length > 0 ? (
                <TableContainer>
                  <Table stickyHeader sx={{ overflow: "auto" }}>
                    <TableHead sx={{ fontWeight: "bold" }}>
                      <TableRow>
                        <TableCell sx={{
                          // width: "15px",
                          padding: "8px"
                        }}>SL#</TableCell>
                        <TableCell sx={{
                          //  width: "80px",
                          padding: "8px"
                        }}>Date</TableCell>
                        {/* <TableCell sx={{
                          // width: "100px",
                          padding: "8px"
                        }}>Title</TableCell> */}
                        <TableCell sx={{
                          //  width: 300, 
                          //  minWidth: 300, 
                          //  maxWidth: 300,
                          padding: "8px"
                        }}>
                          Message
                        </TableCell>
                        <TableCell sx={{
                          // width: "60px", 
                          padding: "8px"
                        }}>Status</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>

                      {emergencyData.Notifications?.map((n, index) => (
                        <TableRow
                          key={n.RecordID}
                          // sx={{ padding: "8px" }} 
                          // onClick={() => handleReadNotification(compID, empID, today, n.RecordID)}
                          onClick={() => setSelectedNotification(n)}
                          sx={{
                            p: 2,
                            cursor: "pointer",
                            borderBottom: "1px solid",
                            borderColor: "divider",

                            bgcolor:
                              selectedNotification?.RecordID === n.RecordID
                                ? "action.selected"
                                : "transparent",

                            "&:hover": {
                              bgcolor: "action.hover",
                            },
                          }}
                        >
                          <TableCell sx={{
                            // width: "15px",
                            padding: "8px"
                          }}>{index + 1}</TableCell>
                          <TableCell sx={{
                            // width: "80px",
                            padding: "8px"
                          }}>{n.CreatedDate}</TableCell>
                          {/* <TableCell sx={{
                            // width: "100px", 
                            padding: "8px"
                          }}>{n.Title}</TableCell> */}
                          <TableCell sx={{
                            //  width: "300px",
                            padding: "8px"
                          }}>{n.Description}</TableCell>
                          <TableCell sx={{
                            // width: "50px", 
                            padding: "8px"
                          }}>
                            <Chip
                              label={n.IsRead === "N" ? "Unread" : "Read"}
                              color={n.IsRead === "N" ? "error" : "success"}
                              size="small"
                            // onClick={() => handleReadNotification(compID, empID,today, n.RecordID)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}


                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 5, gap: 2 }}>
                  <Typography variant="body2" sx={{ p: 3 }}>No notifications available.</Typography>
                </Box>
              )}
            </Box>
            {selectedNotification ?(
            <Box
              sx={{
                flex: 1,
                p: 3,
                overflowY: "auto",
              }}
            >
              {!selectedNotification ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography color="text.secondary">
                    Select a notification to view details
                  </Typography>
                </Box>
              ) : (
                <>
                  <Typography variant="h6" fontWeight={600}>
                    {selectedNotification.Title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                  >
                    {selectedNotification.CreatedDate}
                  </Typography>

                  <Chip
                    sx={{ mt: 2 }}
                    label={
                      selectedNotification.IsRead === "N"
                        ? "Unread"
                        : "Read"
                    }
                    color={
                      selectedNotification.IsRead === "N"
                        ? "error"
                        : "success"
                    }
                  />

                  <Typography
                    sx={{
                      mt: 3,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {selectedNotification.Description}
                  </Typography>

                  <Box
                    sx={{
                      mt: 4,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
 <>
              {selectedNotification?.Attachment && (
<Tooltip title="View Uploaded File">
                                          <IconButton
                                            color="primary"
                                            // disabled={!task.extendedProps?.Attachment}
                                            sx={{
                                              opacity: selectedNotification?.Attachment ? 1 : 0.4,
                                              cursor: selectedNotification?.Attachment
                                                ? "pointer"
                                                : "not-allowed",
                                            }}
                                            onClick={() => {
                                              if (selectedNotification?.Attachment) {
                                                window.open(
                                                 selectedNotification.NotificationType === "E" ?
                                                  `${baseurlBOS}uploads/images/${selectedNotification.Attachment}` 
                                                  :`${baseurl1}uploads/images/${selectedNotification.Attachment}`
                                                 ,
                                                  "_blank",
                                                );
                                              }
                                            }}
                                          >
                                            <FileDownloadOutlinedIcon />
                                          </IconButton>
                                             </Tooltip>
              )}
                                     
                                       
                                        {selectedNotification?.Video && (
                                           <Tooltip title="View Uploaded Video">
  <IconButton
                                            color="primary"
                                            // disabled={!task.extendedProps?.Videos}
                                            sx={{
                                              opacity: selectedNotification?.Video
                                                ? 1
                                                : 0.4,
                                              cursor: selectedNotification?.Video
                                                ? "pointer"
                                                : "not-allowed",
                                            }}
                                            onClick={() => {
                                              if (selectedNotification?.Video) {
                                                window.open(
                                                  // store.getState().globalurl.videoattachmentUrl +
                                                  //   selectedNotification?.Video,
                                                
                                                 selectedNotification.NotificationType === "E" ?
                                                  `${baseurlBOS}uploads/videos/${selectedNotification.Video}` 
                                                  :`${baseurl1}uploads/videos/${selectedNotification.Video}`
                                                 ,
                                               
                                                  "_blank",
                                                );
                                              }
                                            }}
                                          >
                                            <PlayCircleOutlinedIcon />
                                          </IconButton>
                                            </Tooltip>
                                        )}
                                        
                                      
         
                  
                   
                    {selectedNotification?.Audio && (
 <Tooltip title="View Uploaded Audio">
                                          <IconButton
                                            color="primary"
                                            // disabled={!task.extendedProps?.Audio}
                                            sx={{
                                              opacity: selectedNotification?.Audio
                                                ? 1
                                                : 0.4,
                                              cursor: selectedNotification?.Audio
                                                ? "pointer"
                                                : "not-allowed",
                                            }}
                                            onClick={() => {
                                              if (selectedNotification?.Audio) {
                                                window.open(
                                                  // store.getState().globalurl.audioattachmentUrl +
                                                  //   selectedNotification.Audio,
                                                     selectedNotification.NotificationType === "E" ?
                                                  `${baseurlBOS}uploads/audios/${selectedNotification.Audio}` 
                                                  :`${baseurl1}uploads/audios/${selectedNotification.Audio}`
                                                 ,
                                                  "_blank",
                                                );
                                              }
                                            }}
                                          >
                                            <SettingsVoiceIcon />
                                          </IconButton>
                                                  </Tooltip>
                                              
                    )}
        </>                        

                    <Button
                      variant="contained"
                      color={
                        selectedNotification.IsRead === "N"
                          ? "success"
                          : "warning"
                      }
                      onClick={() =>
                        handleReadNotification(
                          compID,
                          empID,
                          today,
                          selectedNotification.RecordID,
                          selectedNotification.IsRead === "N"
                            ? "Y"
                            : "N"
                        )
                      }
                    >
                      {selectedNotification.IsRead === "N"
                        ? "Close Notification"
                        : "Reopen Notification"}
                    </Button>
                  </Box>
                </>
              )}
            </Box>):(false)}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: 2,
              py: 1.5,
              borderTop: "1px solid",
              borderColor: "divider",
              gap: 2
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={() => setNotificationOpen(false)}
            >
              Close
            </Button>

          </Box> */}
        </DialogContent>
      </Dialog>

      <Toolbar sx={{ gap: 1.5, minHeight: "56px !important", px: { xs: 1.5, sm: 3 } }}>
        {/* <Box sx={{ width: 32, height: 32, borderRadius: "9px", background: "linear-gradient(135deg,#3b6ef8,#5b9cf6)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <Activity sx={{ fontSize: 16, color: "#fff" }} />
        </Box> */}
        {/* <Typography variant="subtitle1" fontWeight={600} letterSpacing={-0.2} sx={{ mr: "auto", fontSize: { xs: 11, sm: 14 } }}>
          Project–<Box component="span" color="primary.main">Agile Task Management</Box>
        </Typography> */}
        {/* <Typography variant="h4" fontWeight={900} letterSpacing={-0.2} sx={{ mr: "auto", fontSize: { xs: 11, sm: 14 } }}> */}
        {/* <Typography variant="h4" sx={{ mr: "auto", fontSize: { xs: 12, sm: 15 }, fontFamily: "'Outfit',sans-serif", fontWeight: 700, letterSpacing: 0.2 }}>
          {companyClassification === "Board Of Directors" ? "PRINCIPAL DASHBOARD"
            : companyClassification === "Staff" ? "STAFF DASHBOARD" :
              companyClassification === "Intern" ? "STUDENT DASHBOARD" : "PROJECT MANAGER DASHBOARD"}
        </Typography> */}
        {/* {is003Subscription ? (isprojectmanager == "Y" ? "PROJECT MANAGER DASHBOARD" : "PERSONNEL DASHBOARD") : "PRINCIPAL DASHBOARD"} */}
        <Typography variant="h5" fontWeight="bold" sx={{ mr: "auto", fontSize: { xs: 15, sm: 20 }, }}>
          {getGreeting()}, {EmpName} – {is003Subscription ? "Overview" : is002Subscription ? "Construction Project Overview" : "Project Overview"}
        </Typography>


        <Stack direction={"row"} gap={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: "5px", fontSize: 11, color: '#64748b', padding: '5px 8px', borderRadius: 20, border: '1px solid rgba(0,0,0,0.07)' }}>
            <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
            {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
          </Box>
          {is003Subscription && isprojectmanager == "Y" && (
            <>
              {/* <Tooltip title="Staff Calendar">
                <CustomIconButton
                  onClick={() => {
                    navigate("/Apps/Teacher-dashbord/T");
                    dispatch(
                      dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
                    );
                  }}
                  color="primary"
                >
                  <PermContactCalendarOutlinedIcon />
                </CustomIconButton>
              </Tooltip> */}

              {/* <Tooltip title="Class Calendar">
                <IconButton
                  onClick={() => {
                    navigate("/Apps/ClassCalendar-dashbord/C");
                    dispatch(
                      dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
                    );
                  }}
                  color="primary"
                >
                  <RecentActorsIcon />
                </IconButton>
              </Tooltip> */}
            </>
          )}

          <Tooltip title="Personnel Dashboard">
            <CustomIconButton
              size="small"
              onClick={() => {
                navigate("/Apps/dashbord/E");
                // dispatch(
                //   dashBoardAtten({ data: { EmployeeID: empID, Type: "E" } })
                // );
              }}
              color="primary"
            >
              <RecentActorsIcon />
            </CustomIconButton>
          </Tooltip>
          <Tooltip
            title={isCalendar ? "Project Manager Dashboard" : "Show Calendar"}
          >
            <CustomIconButton
              size="small"
              onClick={() => {
                setIsCalendar(prev => !prev);
                setIsEventCalendar(false);
              }}
              color="primary"
            >
              {isCalendar ? <DashboardIcon /> : <CalendarToday />}
            </CustomIconButton>
            {/* <button 
            onClick={() => setIsCalendar(prev => !prev)} 
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', 
            width: 32, height: 32, borderRadius: 10, 
            border: '1px solid rgba(0,0,0,0.07)', 
            background: isCalendar ? t.accent : t.bg, color: isCalendar ? '#fff' : t.accent, cursor: 'pointer', transition: 'all .18s' }} title={isCalendar ? "Show Dashboard" : "Show Calendar"} onMouseEnter={(e) => { e.currentTarget.style.background = isCalendar ? t.accent : '#f1f5f9'; }} onMouseLeave={(e) => { e.currentTarget.style.background = isCalendar ? t.accent : t.bg; }}>
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /><path d="M9 14h6M9 18h6" /></svg>
            </button> */}
          </Tooltip>

          {is003Subscription && (
            <>
              <Tooltip
                title={isEventCalendar ? "Project Manager Dashboard" : "Show Event Calendar"}
              >
                <CustomIconButton
                  size="small"
                  onClick={() => {
                    setIsEventCalendar(prev => !prev);
                    setIsCalendar(false);
                  }}
                  color="primary"
                >
                  {isEventCalendar ? <DashboardIcon /> : <EventNoteOutlinedIcon />}
                </CustomIconButton>
              </Tooltip>

              <Tooltip
                title="Emergency Alert"
              >
                <CustomIconButton
                  size="small"
                  onClick={() => setNotificationOpen(true)}
                  color="primary"
                >

                  <Badge badgeContent={emergencyData.NotificationCount ? emergencyData.NotificationCount : 0} color="error">
                    <NotificationsActiveOutlinedIcon />
                  </Badge>
                </CustomIconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

// ─── KPI POPUP ────────────────────────────────────────────────────
function KpiPopup({ kpi, onClose }) {
  const [expandedProj, setExpandedProj] = useState(null);
  if (!kpi) return null;
  const kpiIconsPopUp = [
    // <CheckSquare key="0" sx={{ fontSize: 18, color: "#fff" }} />,
    <PendingActionsOutlinedIcon key="0" sx={{ fontSize: 18, color: "#fff" }} />,
    <Clock key="1" sx={{ fontSize: 18, color: "#fff" }} />,
    <CheckCircle key="2" sx={{ fontSize: 18, color: "#fff" }} />,
    <Briefcase key="3" sx={{ fontSize: 18, color: "#fff" }} />,
  ];

  const total = kpi.kpiProjects.reduce((s, p) => s + p.count, 0) || 1;
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Box sx={{ width: 46, height: 46, borderRadius: 2, background: kpi.gradient, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            {/* <CheckSquare sx={{ fontSize: 20, color: "#fff" }} /> */}
            {kpiIconsPopUp[kpi.index]}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} fontSize={16}>{kpi.title}</Typography>
            {/* <Typography variant="caption" color="text.secondary" fontFamily="'DM Mono',monospace">{kpi.count} Tasks Total</Typography> */}
            <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">{kpi.count} Tasks Total</Typography>
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
          {kpi.breakdown.map((b, i) => (
            <Grid item xs key={i}>
              <Paper variant="outlined" sx={{ p: 1.5, textAlign: "center", borderRadius: 2 }}>
                {/* <Typography variant="h6" fontWeight={700} fontFamily="'DM Mono',monospace">{b.value}</Typography> */}
                <Typography variant="h6" fontWeight={700} fontFamily="'Outfit',sans-serif">{b.value}</Typography>
                <Typography variant="caption" color="text.secondary" letterSpacing={0.5}>{b.label}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Typography variant="caption" fontWeight={600} color="text.secondary" letterSpacing={0.6} sx={{ mb: 1, display: "block" }}>By Project</Typography>
        <Stack spacing={1}>
          {kpi.kpiProjects.map((p, i) => {
            const pct = ((p.count / total) * 100).toFixed(0);
            const isOpen = expandedProj === i;
            return (
              // <Paper key={i} variant="outlined" sx={{ p: 1.5, borderRadius: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
              //   <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: p.color, flexShrink: 0 }} />
              //   <Box sx={{ flex: 1 }}>
              //     <Typography fontSize={12} fontWeight={600}>{p.name}</Typography>
              //     <Typography variant="caption" color="text.secondary" fontFamily="'DM Mono',monospace">{p.id}</Typography>
              //   </Box>
              //   <LinearProgress variant="determinate" value={Number(pct)} sx={{ width: 80, height: 6, borderRadius: 99, bgcolor: "action.hover", "& .MuiLinearProgress-bar": { background: p.color } }} />
              //   <Typography fontSize={18} fontWeight={700} fontFamily="'DM Mono',monospace" minWidth={32} textAlign="right">{p.count}</Typography>
              // </Paper>
              <Paper key={i} variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>

                {/* Clickable header row */}
                <Stack
                  direction="row"
                  alignItems="center"
                  gap={1.5}
                  onClick={() => setExpandedProj(isOpen ? null : i)}
                  sx={{
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: isOpen ? alpha("#3b6ef8", .04) : "transparent",
                    transition: "background .15s",
                    "&:hover": { bgcolor: alpha("#3b6ef8", .06) },
                  }}
                >
                  <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: p.color, flexShrink: 0 }} />
                  <Box sx={{ flex: 1 }}>
                    <Typography fontSize={12} fontWeight={600}>{p.name}</Typography>
                    {/* <Typography variant="caption" color="text.secondary" fontFamily="'DM Mono',monospace">{p.id}</Typography> */}
                    <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">{p.id}</Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={Number(pct)}
                    sx={{
                      width: 80, height: 6, borderRadius: 99,
                      bgcolor: "action.hover",
                      "& .MuiLinearProgress-bar": { background: p.color },
                    }}
                  />
                  <Typography
                    fontSize={18}
                    fontWeight={700}
                    // fontFamily="'DM Mono',monospace" 
                    fontFamily="'Outfit',sans-serif"
                    minWidth={32}
                    textAlign="right">
                    {p.count}
                  </Typography>
                  <ChevronRight sx={{
                    fontSize: 16, color: "text.disabled", flexShrink: 0,
                    transform: isOpen ? "rotate(90deg)" : "none",
                    transition: "transform .2s",
                  }} />
                </Stack>

                {/* Expanded task table */}
                {isOpen && (p.tasks?.length > 0) && (
                  <Box sx={{ borderTop: "1px solid", borderColor: "divider", bgcolor: "action.hover" }}>
                    <TableContainer>
                      <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                        <TableHead>
                          <TableRow sx={{ bgcolor: "action.selected" }}>
                            <TableCell sx={{ width: "30%", py: 0.5, fontSize: 12, fontWeight: 600 }}>
                              Task
                            </TableCell>
                            <TableCell sx={{ width: "15%", py: 0.5, fontSize: 12, fontWeight: 600 }}>
                              Source
                            </TableCell>
                            <TableCell sx={{ width: "15%", py: 0.5, fontSize: 12, fontWeight: 600 }}>
                              Priority
                            </TableCell>
                            <TableCell sx={{ width: "20%", py: 0.5, fontSize: 12, fontWeight: 600 }}>
                              Targeted Date
                            </TableCell>
                            <TableCell sx={{ width: "20%", py: 0.5, fontSize: 12, fontWeight: 600 }}>
                              Employee
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {p.tasks.map((t, ti) => (
                            <TableRow key={ti} hover>
                              <TableCell sx={{ maxWidth: 250 }}>
                                <Typography
                                  fontSize={12}
                                  fontWeight={500}
                                  noWrap
                                  title={t.description}
                                >
                                  {t.title}
                                </Typography>
                              </TableCell>

                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography fontSize={12}>{t.source}</Typography>
                              </TableCell>

                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Chip label={t.priority} size="small" />
                              </TableCell>

                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography fontSize={12}>{t.date}</Typography>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography fontSize={12}>{t.empname}</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}

                {/* Empty state */}
                {isOpen && (!p.tasks || p.tasks.length === 0) && (
                  <Box sx={{ px: 2, py: 1.5, borderTop: "1px solid", borderColor: "divider", bgcolor: "action.hover" }}>
                    <Typography variant="caption" color="text.secondary">No task details available.</Typography>
                  </Box>
                )}
              </Paper>
            );
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

// ─── EMPLOYEE MODAL ───────────────────────────────────────────────
function EmpModal({ person, color, empTasksMap, onClose }) {
  if (!person) return null;
  const tasks = empTasksMap[person.id] || [];
  const totalEst = tasks.reduce((s, t) => s + t.est, 0);
  const totalAct = tasks.reduce((s, t) => s + t.act, 0);
  const variance = +(totalAct - totalEst).toFixed(1);
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 42, height: 42, bgcolor: color, borderRadius: 2, fontWeight: 700, fontSize: 13 }}>{person.init}</Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} fontSize={15}>{person.name}</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              // fontFamily="'DM Mono',monospace"
              fontFamily="'Outfit',sans-serif"
            >
              {person.id} · {person.cost} · {person.util}% Utilization
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
          {[
            ["Total Tasks", tasks.length, "text.primary"],
            ["Est. Hours", totalEst.toFixed(1) + " Hr", "text.primary"],
            ["Actual Hours", totalAct.toFixed(1) + " Hr", "text.primary"],
            ["Variance", (variance > 0 ? "+" : "") + variance + " Hr", variance > 0 ? "error.main" : variance < 0 ? "success.main" : "warning.main"],
          ].map(([label, value, c], i) => (
            <Grid item xs={6} sm={3} key={i}>
              <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                <Typography variant="caption" color="text.secondary" letterSpacing={0.5} display="block" sx={{ mb: .5 }}>{label}</Typography>
                <Typography
                  fontSize={18}
                  fontWeight={600}
                  // fontFamily="'DM Mono',monospace" 
                  fontFamily="'Outfit',sans-serif"
                  color={c}>{value}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Typography variant="caption" fontWeight={600} color="text.secondary" letterSpacing={0.6} sx={{ mb: 1, display: "block" }}>Task Breakdown</Typography>
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead><TableRow>{["Task", "Project", "Est Hr", "Act Hr", "Variance", "Status", "Date"].map(h => <TableCell key={h}>{h}</TableCell>)}</TableRow></TableHead>
            <TableBody>
              {tasks.map((t, i) => {
                const v = +(t.act - t.est).toFixed(1);
                const sm = STATUS_META[t.status] || STATUS_META.I;
                return (
                  <TableRow key={i} hover>
                    {/* <TableCell> */}
                    {/* <Typography fontSize={12} fontWeight={500} noWrap sx={{ maxWidth: { xs: 100, sm: 200 } }}>{t.name}</Typography> */}
                    {/* <Typography variant="caption" color="text.secondary" fontFamily="'DM Mono',monospace">{t.code}</Typography> */}
                    {/* </TableCell> */}
                    <TableCell sx={{ maxWidth: 250 }}>
                      <Typography
                        fontSize={12}
                        fontWeight={500}
                        noWrap
                        title={t.name}
                      >
                        {t.name}
                      </Typography>
                    </TableCell>
                    <TableCell><Typography variant="caption" fontFamily="'Outfit',sans-serif" color="text.secondary">{t.project}</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{t.est}Hr</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{t.act}Hr</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12} color={v > 0 ? "error.main" : v < 0 ? "success.main" : "warning.main"}>{(v > 0 ? "+" : "") + v}Hr</Typography></TableCell>
                    <TableCell><Chip label={sm.label} size="small" color={sm.color} variant="outlined" /></TableCell>
                    <TableCell><Typography variant="caption" color="text.secondary">{t.date}</Typography></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}

// ─── PROJECT MODAL ───────────────────────────────────────────────
function ProjectModal({ project, projectEmployeeMap, onClose, colors }) {
  const [selectedEmp, setSelectedEmp] = useState(null);
  if (!project) return null;

  const employees = projectEmployeeMap?.[project.id] || [];
  const totalEst = employees.reduce((s, e) => s + e.tasks.reduce((ts, t) => ts + t.est, 0), 0);
  const totalAct = employees.reduce((s, e) => s + e.tasks.reduce((ts, t) => ts + t.act, 0), 0);
  const totalTasks = employees.reduce((s, e) => s + e.tasks.length, 0);
  const sb = PROJ_STATUS[project.status] || PROJ_STATUS.active;
  const safeColors = colors || DEFAULT_COLORS;
  const AVcolor = safeColors;
  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      {/* ── Header ── */}
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Box sx={{ width: 46, height: 46, borderRadius: 2, background: "linear-gradient(135deg,#3b6ef8,#5b9cf6)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <AssignmentIcon sx={{ fontSize: 22, color: "#fff" }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
              <Typography fontWeight={600} fontSize={16}>{project.name}</Typography>
              <Chip label={sb.label} size="small" color={sb.color} variant="outlined" sx={{ fontSize: 10 }} />
            </Stack>
            <Typography
              variant="caption"
              color="text.secondary"
              // fontFamily="'DM Mono',monospace"
              fontFamily="'Outfit',sans-serif"
            >
              {project.id} · {project.tasks} Tasks · {project.prog}% Complete
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
        </Stack>
      </DialogTitle>
      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        {/* ── Summary stats ── */}
        <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
          {[
            ["Employees", employees.length, "text.primary"],
            ["Total Tasks", totalTasks, "text.primary"],
            ["Est. Hours", totalEst.toFixed(1) + " Hr", "text.primary"],
            ["Actual Hours", totalAct.toFixed(1) + " Hr", totalAct > totalEst ? "error.main" : "success.main"],
          ].map(([label, value, c], i) => (
            <Grid item xs={6} sm={3} key={i}>
              <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                <Typography variant="caption" color="text.secondary"
                  letterSpacing={0.5} display="block" sx={{ mb: .5 }}>{label}</Typography>
                <Typography
                  fontSize={18}
                  fontWeight={600}
                  fontFamily="'Outfit',sans-serif" color={c}>{value}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* ── Progress bar ── */}
        <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 2.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600} flexShrink={0}>Progress</Typography>
          <LinearProgress variant="determinate" value={project.prog}
            color={PROJ_BAR_COLOR[project.status] || "success"}
            sx={{ flex: 1, height: 8, borderRadius: 99 }} />
          <Typography fontSize={12} fontWeight={700} fontFamily="'Outfit',sans-serif" flexShrink={0}>{project.prog}%</Typography>
        </Stack>

        {/* ── Employee list ── */}
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
          <GroupIcon sx={{ fontSize: 15, color: "text.secondary" }} />
          <Typography variant="caption" fontWeight={600} color="text.secondary"
            letterSpacing={0.6}>
            Team Members ({employees.length})
          </Typography>
        </Stack>

        {employees.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
            No employees assigned to this project.
          </Typography>
        ) : (
          <Stack spacing={1.25}>
            {employees.map((emp, i) => {
              const empEst = emp.tasks.reduce((s, t) => s + t.est, 0);
              const empAct = emp.tasks.reduce((s, t) => s + t.act, 0);
              const variance = +(empAct - empEst).toFixed(1);
              // const color = AVcolor[i % AVcolor.length];
              const color = AVATAR_COLORS[i % AVATAR_COLORS.length];
              const isExpanded = selectedEmp === emp.id;

              return (
                <Paper key={emp.id} variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
                  {/* Employee row — clickable to expand tasks */}
                  <Stack direction="row" alignItems="center" gap={1.25} sx={{
                    p: "10px 14px", cursor: "pointer",
                    bgcolor: isExpanded ? alpha("#3b6ef8", .04) : "transparent",
                    transition: "background .15s",
                    "&:hover": { bgcolor: alpha("#3b6ef8", .06) },
                  }} onClick={() => setSelectedEmp(isExpanded ? null : emp.id)}>
                    <Avatar sx={{ width: 36, height: 36, bgcolor: color, borderRadius: "10px", fontWeight: 700, fontSize: 11, flexShrink: 0 }}>{emp.init}</Avatar>

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography fontSize={12} fontWeight={600} noWrap>{emp.name}</Typography>
                      <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">{emp.id}</Typography>
                    </Box>

                    {/* Mini stats */}
                    <Stack direction="row" gap={2} sx={{ display: { xs: "none", sm: "flex" }, flexShrink: 0 }}>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography fontSize={11} fontWeight={600} fontFamily="'Outfit',sans-serif">{emp.tasks.length}</Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={9}>Tasks</Typography>
                      </Box>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography fontSize={11} fontWeight={600} fontFamily="'Outfit',sans-serif">{empEst.toFixed(1)}Hr</Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={9}>Est.</Typography>
                      </Box>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography fontSize={11} fontWeight={600} fontFamily="'Outfit',sans-serif">{empAct.toFixed(1)}Hr</Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={9}>Actual</Typography>
                      </Box>
                      <Box sx={{ textAlign: "center" }}>
                        <Typography fontSize={11} fontWeight={600} fontFamily="'Outfit',sans-serif"
                          color={variance > 0 ? "error.main" : variance < 0 ? "success.main" : "warning.main"}>
                          {(variance > 0 ? "+" : "") + variance}Hr
                        </Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={9}>Var.</Typography>
                      </Box>
                    </Stack>

                    <Box sx={{ textAlign: "right", flexShrink: 0, ml: 1 }}>
                      <Typography fontSize={12} fontWeight={600}>{emp.cost}</Typography>
                      <LinearProgress variant="determinate" value={Math.min(emp.util * 3, 100)}
                        color="success" sx={{ width: 50, height: 3, borderRadius: 99, mt: .5 }} />
                    </Box>

                    {/* Expand chevron */}
                    <ChevronRight sx={{
                      fontSize: 16, color: "text.disabled", flexShrink: 0,
                      transform: isExpanded ? "rotate(90deg)" : "none",
                      transition: "transform .2s"
                    }} />
                  </Stack>

                  {/* ── Expanded task table ── */}
                  {isExpanded && (
                    <Box sx={{ borderTop: "1px solid", borderColor: "divider", bgcolor: "action.hover" }}>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ bgcolor: "action.selected" }}>
                              {/* {["Task Code", "Task Name", "Est h", "Act h", "Variance", "Status", "Date"].map(h => ( */}
                              {["Task", "Est Hr", "Act Hr", "Variance", "Status", "Date"].map(h => (
                                <TableCell key={h}>{h}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {emp.tasks.map((t, ti) => {
                              const v = +(t.act - t.est).toFixed(1);
                              const sm = STATUS_META[t.status] || STATUS_META.I;
                              return (
                                <TableRow key={ti} hover sx={{ bgcolor: "background.paper" }}>
                                  {/* <TableCell>
                                    <Typography variant="caption" fontFamily="'DM Mono',monospace" color="text.secondary">{t.code}</Typography>
                                  </TableCell> */}
                                  <TableCell>
                                    {/* <Typography fontSize={12} fontWeight={500} noWrap sx={{ maxWidth: { xs: 100, sm: 180 } }}>{t.name}</Typography> */}
                                    <Typography fontSize={12} fontWeight={500} noWrap sx={{ maxWidth: { xs: 100, sm: 180 } }} title={t.name}>{t.title}</Typography>
                                  </TableCell>
                                  <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{t.est}Hr</Typography></TableCell>
                                  <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{t.act}Hr</Typography></TableCell>
                                  <TableCell>
                                    <Typography fontFamily="'Outfit',sans-serif" fontSize={12}
                                      color={v > 0 ? "error.main" : v < 0 ? "success.main" : "warning.main"}>
                                      {(v > 0 ? "+" : "") + v}Hr
                                    </Typography>
                                  </TableCell>
                                  <TableCell><Chip label={sm.label} size="small" color={sm.color} variant="outlined" /></TableCell>
                                  <TableCell><Typography variant="caption" color="text.secondary">{t.date}</Typography></TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                </Paper>
              );
            })}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

// ─── EFFORT DRILLDOWN MODAL ───────────────────────────────────────
function EffortModal({ projectCode, effortData, dark, onClose, colors }) {
  const d = effortData?.drilldown?.[projectCode];
  const codeToNameMap = Object.fromEntries(
    effortData.labels.map((code, i) => [code, effortData.projects[i]])
  );
  const safeColors = colors || DEFAULT_COLORS;

  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;

  const projectName = codeToNameMap[projectCode] || projectCode;
  if (!d || !projectCode) return null;
  const { gridC, tickC, tf } = chartColors(dark);
  const chartData = {
    labels: d.employees.map(e => e.name),
    datasets: [
      { label: "Estimated", data: d.employees.map(e => e.est), backgroundColor: toDoColor, borderRadius: 5, borderSkipped: false },
      { label: "Actual", data: d.employees.map(e => e.act), backgroundColor: completedColor, borderRadius: 5, borderSkipped: false },
    ],
  };
  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: { legend: { display: true, position: "top", labels: { font: tf, boxWidth: 10, padding: 12, color: tickC } } },
    scales: { x: { grid: { display: false }, ticks: { font: tf, color: tickC } }, y: { grid: { color: gridC }, ticks: { font: tf, color: tickC } } },
  };
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600} fontSize={15}>Employee Hour Split</Typography>
            <Typography fontWeight={600} fontSize={13}>{projectCode} || {projectName}</Typography>
            <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">
              Est: {d.est}Hr · Actual: {d.act}Hr · Variance: {d.act > d.est ? "+" : ""}{+(d.act - d.est).toFixed(0)}Hr
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ height: 220, mb: 2 }}><Bar data={chartData} options={options} /></Box>
        <Typography variant="caption" fontWeight={600} color="text.secondary" letterSpacing={0.6} sx={{ mb: 1, display: "block" }}>Employee Breakdown</Typography>
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead><TableRow>{["Employee", "Est. Hr", "Actual Hr", "Variance"].map(h => <TableCell key={h}>{h}</TableCell>)}</TableRow></TableHead>
            <TableBody>
              {d.employees.map((e, i) => {
                const v = e.act - e.est;
                return (
                  <TableRow key={i} hover>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12} fontWeight={500}>{e.name}</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{e.est}Hr</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12}>{e.act}Hr</Typography></TableCell>
                    <TableCell><Typography fontFamily="'Outfit',sans-serif" fontSize={12} color={v > 0 ? "error.main" : v < 0 ? "success.main" : "warning.main"}>{(v > 0 ? "+" : "") + v.toFixed(2)}Hr</Typography></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}

// ─── DONUT CHART ──────────────────────────────────────────────────
// KEY FIX: height is locked to CHART_CONTENT_HEIGHT so it matches the bar chart card
function DonutChart({ data }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const chartData = {
    labels: data.map(d => d.label),
    datasets: [{ data: data.map(d => d.value), backgroundColor: data.map(d => d.color), borderWidth: 3, borderColor: "transparent", hoverOffset: 6 }],
  };
  const options = {
    responsive: true, maintainAspectRatio: false, cutout: "72%",
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: { label: ctx => ` ${ctx.label}: ${ctx.parsed} (${((ctx.parsed / total) * 100).toFixed(1)}%)` } },
    },
  };
  return (
    <Box sx={{ height: CHART_CONTENT_HEIGHT, display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: "center", gap: 2 }}>
      {/* Donut canvas */}
      <Box sx={{ position: "relative", width: { xs: "100%", sm: 170 }, height: { xs: 160, sm: "100%" }, flexShrink: 0 }}>
        <Doughnut data={chartData} options={options} />
        <Box sx={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
          <Typography fontSize={22} fontWeight={700} fontFamily="'Outfit',sans-serif">{total}</Typography>
          <Typography variant="caption" color="text.secondary" letterSpacing={0.5}>Total</Typography>
        </Box>
      </Box>
      {/* Legend */}
      <Stack sx={{ flex: 1, width: "100%" }} spacing={1.2} justifyContent="center">
        {data.map((d, i) => {
          // const pct = ((d.value / total) * 100).toFixed(1);
          const pct = total > 0 ? (d.value / total) * 100 : 0;

          return (
            <Stack key={i} direction="row" alignItems="center" gap={1}>
              <Box sx={{ width: 10, height: 10, borderRadius: "3px", bgcolor: d.color, flexShrink: 0 }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: .25 }}>
                  <Typography fontSize={11} fontWeight={500}>{d.label}</Typography>
                  <Typography fontSize={11} color="text.secondary" fontFamily="'Outfit',sans-serif">{d.value}</Typography>
                </Stack>
                <LinearProgress variant="determinate" value={Number(pct)} sx={{ height: 4, borderRadius: 99, bgcolor: "action.hover", "& .MuiLinearProgress-bar": { bgcolor: d.color } }} />
              </Box>
              <Typography fontSize={10} color="text.secondary" fontFamily="'Outfit',sans-serif" flexShrink={0}>
                {/* {pct}% */}
                {pct.toFixed(1)}%
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
}

// ─── EFFORT BAR CHART ─────────────────────────────────────────────
// KEY FIX: outer wrapper is also CHART_CONTENT_HEIGHT — matches DonutChart exactly
function EffortChart({ data, dark, onBarClick, colors }) {
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const is002Subscription = SubscriptionCode.endsWith("002");


  const { gridC, tickC, tf } = chartColors(dark);
  const codeToNameMap = Object.fromEntries(
    data.labels.map((code, i) => [code, data.projects[i]])
  );
  const safeColors = colors || DEFAULT_COLORS;

  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;
  const chartData = {
    labels: data.labels,

    datasets: [
      { label: "Estimated", data: data.estimated, backgroundColor: toDoColor, borderRadius: 5, borderSkipped: false },
      { label: "Actual", data: data.actual, backgroundColor: completedColor, borderRadius: 5, borderSkipped: false },
    ],
  };
  const options = {
    responsive: true, maintainAspectRatio: false,
    onHover: (e, el) => { e.native.target.style.cursor = el.length ? "pointer" : "default"; },
    onClick: (e, el) => { if (el.length) onBarClick(data.labels[el[0].index]); },
    // plugins: { legend: { display: false } },
    plugins: {
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            const code = tooltipItems[0].label;
            return codeToNameMap[code] || code;
          },
          label: (ctx) => {
            const label = ctx.dataset.label;
            return `${label}: ${ctx.raw} Hr`;
          }
        }
      }
    },
    scales: {
      x: { grid: { display: false }, ticks: { font: tf, color: tickC } },
      y: { grid: { color: gridC }, ticks: { font: tf, color: tickC } },
    },
  };
  // Hint row + chart canvas + legend row all live inside the fixed-height box
  return (
    <Box sx={{ height: CHART_CONTENT_HEIGHT, display: "flex", flexDirection: "column" }}>
      <Stack direction="row" alignItems="center" gap={.5} sx={{ mb: .75, flexShrink: 0 }}>
        <Info sx={{ fontSize: 11, color: "text.secondary" }} />
        <Typography variant="caption" color="text.secondary">
          {is003Subscription ? "Click any bar to see personnel hour split" : "Click any bar to see employee hour split"}
          {/* Click any bar to see employee hour split */}
        </Typography>
      </Stack>
      <Box sx={{ flex: 1, position: "relative", minHeight: 0 }}>
        <Bar data={chartData} options={options} />
      </Box>
      <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 1, flexShrink: 0 }}>
        {[[toDoColor, "Estimated"], [completedColor, "Actual"]].map(([c, l]) => (
          <Stack key={l} direction="row" alignItems="center" gap={.625}>
            <Box sx={{ width: 8, height: 8, borderRadius: "2px", bgcolor: c, flexShrink: 0 }} />
            <Typography fontSize={11} color="text.secondary">{l}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

// ─── TREND LINE CHART ─────────────────────────────────────────────
function TrendChart({ data, dark }) {
  const { gridC, tickC, tf } = chartColors(dark);
  const gradientPlugin = useCallback((ctx) => {
    const canvas = ctx?.chart?.canvas;
    if (!canvas) return "rgba(59,110,248,.1)";
    const c = canvas.getContext("2d");
    const grad = c.createLinearGradient(0, 0, 0, 170);
    grad.addColorStop(0, "rgba(59,110,248,.18)");
    grad.addColorStop(1, "rgba(59,110,248,0)");
    return grad;
  }, []);
  const chartData = {
    labels: data.labels,
    datasets: [
      { label: "Completed", data: data.actual, borderColor: toDoColor, borderWidth: 2.5, backgroundColor: gradientPlugin, fill: true, tension: .45, pointBackgroundColor: toDoColor, pointBorderColor: "#fff", pointBorderWidth: 2, pointRadius: 4, pointHoverRadius: 6 },
      { label: "Target", data: data.target, borderColor: gridC, borderWidth: 1.5, borderDash: [5, 4], backgroundColor: "transparent", fill: false, tension: .45, pointRadius: 0, pointHoverRadius: 4 },
    ],
  };
  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { mode: "index", intersect: false, callbacks: { label: ctx => ` ${ctx.dataset.label}: ${ctx.parsed.y} tasks` } } },
    scales: {
      x: { grid: { display: false }, ticks: { font: tf, color: tickC }, border: { display: false } },
      y: { grid: { color: gridC }, ticks: { font: tf, color: tickC, stepSize: 10 }, border: { display: false } },
    },
  };
  return <Line data={chartData} options={options} />;
}

// ─── MILESTONE TIMELINE ───────────────────────────────────────────
function MilestoneTimeline({ data, colors }) {
  const [tooltip, setTooltip] = useState(null);
  // const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];

  const now = new Date();
  const months = Array.from(
    { length: now.getMonth() + 1 }, // current month index + 1
    (_, i) =>
      new Date(now.getFullYear(), i).toLocaleString("default", {
        month: "short",
      })
  );

  console.log(months, "--find dynamic months");
  const todayPct = tlPct("2026-03-20");
  const safeColors = colors || DEFAULT_COLORS;

  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;

  if (!data?.length) return <Typography variant="body2" color="text.secondary">No milestone data</Typography>;
  return (
    <Box sx={{ overflowX: "auto", pb: .75 }}>
      <Box sx={{ minWidth: 480, py: .75 }}>
        <Stack direction="row" sx={{ ml: "110px", mb: 1 }}>
          {months.map((m, i) => (
            <Box key={i} sx={{ flex: 1, pl: .5, borderLeft: "1px dashed", borderColor: "divider" }}>
              <Typography variant="caption" fontWeight={700} color="text.disabled" fontSize={9} letterSpacing={0.6}>{m}</Typography>
            </Box>
          ))}
        </Stack>
        <Box sx={{ position: "relative" }}>
          {/* Today line */}
          <Box sx={{ position: "absolute", top: 0, bottom: 0, width: "1.5px", background: "linear-gradient(180deg,#ef4444,rgba(239,68,68,0))", zIndex: 5, pointerEvents: "none", left: `calc(110px + (100% - 110px)*${todayPct / 100})` }}>
            <Box sx={{ position: "absolute", top: -2, transform: "translateX(-50%)", fontSize: 8, fontWeight: 700, color: "#ef4444", bgcolor: "background.paper", border: "1px solid #ef4444", borderRadius: .5, px: .5, py: "1px", whiteSpace: "nowrap" }}>Today</Box>
          </Box>
          {data.map((p, pi) => {
            const sp = tlPct(p.start), ep = tlPct(p.end);
            return (
              <Stack key={pi} direction="row" alignItems="center" sx={{ mb: 1.25 }}>
                <Box sx={{ width: 106, flexShrink: 0, pr: 1 }}>
                  <Typography fontSize={11} fontWeight={600} noWrap title={p.name}>{p.name}</Typography>
                  <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif" fontSize={9}>{p.id}</Typography>
                </Box>
                <Box sx={{ flex: 1, height: 28, bgcolor: "action.hover", borderRadius: "6px", position: "relative", border: "1px solid", borderColor: "divider" }}>
                  <Box sx={{ position: "absolute", top: 5, height: 18, borderRadius: "5px", bgcolor: p.color, opacity: .9, left: `${sp}%`, width: `${ep - sp}%` }} />
                  {
                    (p.milestones && p.milestones.length > 0) ?
                      (p.milestones || []).map((m, mi) => {
                        const mp = tlPct(m.date), color = m.done ? completedColor : approvedColor, key = `${pi}-${mi}`;
                        return (
                          <Box key={mi} sx={{ position: "absolute", top: "50%", transform: "translateY(-50%)", left: `${mp}%`, zIndex: 4 }}
                            onMouseEnter={() => setTooltip({ key, label: m.label, date: m.date })}
                            onMouseLeave={() => setTooltip(null)}>
                            <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%) rotate(45deg)", width: 10, height: 10, borderRadius: "2px", bgcolor: color, border: "2px solid", borderColor: "background.paper", cursor: "pointer" }} />
                            {tooltip?.key === key && (
                              <Box sx={{ position: "absolute", bottom: "calc(100% + 14px)", left: "50%", transform: "translateX(-50%)", bgcolor: "text.primary", color: "background.paper", fontSize: 10, fontWeight: 500, borderRadius: 1, px: 1, py: .5, whiteSpace: "nowrap", zIndex: 20, boxShadow: "0 4px 12px rgba(0,0,0,.25)" }}>
                                {m.label} {m.date}
                                <Box sx={{ position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "5px solid transparent", borderRight: "5px solid transparent", borderTop: "5px solid", borderTopColor: "text.primary" }} />
                              </Box>
                            )}
                          </Box>
                        );
                      }) : (
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          No milestones available
                        </Typography>
                      )}
                </Box>
              </Stack>
            );
          })}
        </Box>
        <Stack direction="row" flexWrap="wrap" gap={1.75} sx={{ mt: 1, pt: 1, borderTop: "1px solid", borderColor: "divider" }}>
          {[[toDoColor, "bar", "Active"], [blockedColor, "bar", "At Risk"], [backLogColor, "bar", "Overdue"], [approvedColor, "diamond", "Milestone"], [completedColor, "diamond", "Completed"]].map(([c, t, l], i) => (
            <Stack key={i} direction="row" alignItems="center" gap={.625}>
              {t === "bar" ? <Box sx={{ width: 16, height: 8, borderRadius: "3px", bgcolor: c }} /> : <Box sx={{ width: 8, height: 8, borderRadius: "1px", transform: "rotate(45deg)", bgcolor: c, flexShrink: 0 }} />}
              <Typography fontSize={10} color="text.secondary">{l}</Typography>
            </Stack>
          ))}
          <Stack direction="row" alignItems="center" gap={.625} sx={{ ml: "auto" }}>
            <Box sx={{ width: 2, height: 12, bgcolor: backLogColor, borderRadius: .125 }} />
            <Typography fontSize={10} color="error.main" fontWeight={600}>Today</Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}

// ─── STACKED BAR CHART ───────────────────────────────────────────
function StackedStatusChart({ data, dark, colors }) {
  const { gridC, tickC, tf } = chartColors(dark);
  const safeColors = colors || DEFAULT_COLORS;

  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;

  const chartData = {
    labels: data.labels,
    datasets: [
      { label: "Completed", data: data.completed, backgroundColor: completedColor, borderRadius: 0, borderSkipped: false },
      // { label: "In Progress", data: data.inProgress, backgroundColor: "#3b6ef8", borderRadius: 0, borderSkipped: false },
      { label: "Approved", data: data.approved, backgroundColor: approvedColor, borderRadius: 0, borderSkipped: false },
      { label: "To Do", data: data.todo, backgroundColor: toDoColor, borderRadius: 0, borderSkipped: false },
      { label: "Blocked", data: data.blocked, backgroundColor: blockedColor, borderRadius: 0, borderSkipped: false },
      { label: "Rejected", data: data.rejected, backgroundColor: rejectedColor, borderRadius: 0, borderSkipped: false },
      { label: "Transferred", data: data.transferred, backgroundColor: transferredColor, borderRadius: 0, borderSkipped: false },
      {
        label: "Backlog", data: data.backlog, backgroundColor: backLogColor,
        borderRadius: { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 },
        borderSkipped: false
      },
    ],
  };
  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        mode: "index", intersect: false,
        callbacks: {
          footer: (items) => "Total: " + items.reduce((s, i) => s + i.parsed.y, 0) + " tasks",
        },
      },
    },
    scales: {
      x: { stacked: true, grid: { display: false }, ticks: { font: tf, color: tickC } },
      y: { stacked: true, grid: { color: gridC }, ticks: { font: tf, color: tickC, stepSize: 20 } },
    },
  };
  return <Bar data={chartData} options={options} />;
}
// ─── BudgetStatusChart ───────────────────────────────────────────
function BudgetStatusChart({ data, dark, colors }) {
  const { gridC, tickC, tf } = chartColors(dark);
  const safeColors = colors || DEFAULT_COLORS;

  const completedColor = safeColors.completed;
  const toDoColor = safeColors.toDo;
  const backLogColor = safeColors.backLog;
  const approvedColor = safeColors.approved;
  const blockedColor = safeColors.blocked;
  const rejectedColor = safeColors.rejected;
  const transferredColor = safeColors.transferred;
  const totalTaskColor = safeColors.totalTask;

  // const chartData = {
  //   labels: data.labels,
  //   datasets: [
  //     { label: "Completed", data: data.completed, backgroundColor: completedColor, borderRadius: 0, borderSkipped: false },
  //     // { label: "In Progress", data: data.inProgress, backgroundColor: "#3b6ef8", borderRadius: 0, borderSkipped: false },
  //     { label: "Approved", data: data.approved, backgroundColor: approvedColor, borderRadius: 0, borderSkipped: false },
  //     { label: "To Do", data: data.todo, backgroundColor: toDoColor, borderRadius: 0, borderSkipped: false },
  //     { label: "Blocked", data: data.blocked, backgroundColor: blockedColor, borderRadius: 0, borderSkipped: false },
  //     { label: "Rejected", data: data.rejected, backgroundColor: rejectedColor, borderRadius: 0, borderSkipped: false },
  //     { label: "Transferred", data: data.transferred, backgroundColor: transferredColor, borderRadius: 0, borderSkipped: false },
  //     {
  //       label: "Backlog", data: data.backlog, backgroundColor: backLogColor,
  //       borderRadius: { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 },
  //       borderSkipped: false
  //     },
  //   ],
  // };
  const  budgetTracking = {
    "title": "Budget Tracking",
    "subtitle": "Allotted vs Actual vs Overall Budget",
    "labels": [
      "W1 May",
      "W2 May",
      "W3 May",
      "W4 May",
      "W1 Jun",
      "W2 Jun",
      "W3 Jun",
      "W4 Jun",
      "W1 Jul",
      "W2 Jul",
      "W3 Jul",
      "W4 Jul",
      "W1 Aug",
      "W2 Aug",
      "W3 Aug",
      "W4 Aug",
      "W1 Sep",
      "W2 Sep",
      "W3 Sep",
      "W4 Sep"
    ],
    "allottedCost": [
      40000,
      90000,
      95000,
      85000,
      80000,
      60000,
      65000,
      95000,
      100000,
      100000,
      40000,
      80000,
      60000,
      95000,
      40000,
      30000,
      20000,
      100000,
      75000,
      55000
    ],
    "actualCost": [
      25000,
      85000,
      100000,
      120000,
      75000,
      55000,
      60000,
      90000,
      100000,
      100000,
      38000,
      75000,
      55000,
      90000,
      35000,
      25000,
      18000,
      120000,
      120000,
      125000
    ],
    "overallBudget": 120000,
    "overBudget": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      280000,
      0,
      160000
    ]
  }
  const budgetTrackingData = {
  labels: budgetTracking.labels,
  datasets: [
    {
      label: "Allotted Cost",
      backgroundColor: "#2563eb",
      data: budgetTracking.allottedCost,
    },
    {
      label: "Actual Cost",
      backgroundColor: "#10b981",
      data: budgetTracking.actualCost,
    },
    {
      label: "Over Budget",
      backgroundColor: "#ef4444",
      data: budgetTracking.overBudget,
    },
    {
      label: "Overall Budget",
      type: "line",
      borderColor: "#8b5cf6",
      borderDash: [6, 4],
      borderWidth: 2,
      pointRadius: 0,
      fill: false,
      data: budgetTracking.labels.map(
        () => budgetTracking.overallBudget
      ),
    },
  ],
};
  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        mode: "index", intersect: false,
        callbacks: {
          footer: (items) => "Total: " + items.reduce((s, i) => s + i.parsed.y, 0) + " tasks",
        },
      },
    },
    scales: {
      x: { stacked: true, grid: { display: false }, ticks: { font: tf, color: tickC } },
      y: { stacked: true, grid: { color: gridC }, ticks: { font: tf, color: tickC, stepSize: 20 } },
    },
  };
  return <Bar data={budgetTrackingData} options={options} />;
}
// ─── MAIN DASHBOARD ───────────────────────────────────────────────
export default function ProjectManagerDashboardV1() {
  const dispatch = useDispatch();
  const location = useLocation();
  const state = location.state || "";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dark] = useState(false);
  const [kpiPopup, setKpiPopup] = useState(null);
  const [projModal, setProjModal] = useState(null);
  const [empModal, setEmpModal] = useState(null);
  const [effortModal, setEffortModal] = useState(null);
  const [projSearch, setProjSearch] = useState("");
  const [persSearch, setPersSearch] = useState("");
  const [projOff, setProjOff] = useState(0);
  const PP = 8;
  const [persOff, setPersOff] = useState(0);
  const PP_PERS = 5;
  const [actionOff, setActionOff] = useState(0);
  const PP_ACTION = 4; // or 4 depending on how many you want per page
  const EmployeeID = sessionStorage.getItem("EmpId");
  const CompanyID = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [requestEmpId, setRequestEmpId] = useState(null);
  const isManager = sessionStorage.getItem("isManager");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const is002Subscription = SubscriptionCode.endsWith("002");
  const ProjectManagerDashboardData = useSelector((state) => state.formApi.ProjectManagerDashboardData);
  console.log("****ProjectManagerDashboardData", ProjectManagerDashboardData)
  const emergencyData = useSelector((state) => state.formApi.EventNotificationData);
  console.log("🚀 ~ EmployeeDashboard ~ emergencyData:", emergencyData)
  const emergencyDataLoading = useSelector((state) => state.formApi.EventNotificationloading);
  const [isCalendar, setIsCalendar] = useState(false);
  const [isEventCalendar, setIsEventCalendar] = useState(false);
  const AVATAR_COLORS = ["#1d4ed8", "#dc2626", "#059669", "#d97706", "#7c3aed", "#0e7490", "#94a3b8"];
  const overallColors = ProjectManagerDashboardData?.Colours;
  const safeColors = overallColors || DEFAULT_COLORS;
  console.log("****overallColors", overallColors);
  const completedColor = safeColors?.completed;
  const toDoColor = safeColors?.toDo;
  const backLogColor = safeColors?.backLog;
  const approvedColor = safeColors?.approved;
  const blockedColor = safeColors?.blocked;
  const rejectedColor = safeColors?.rejected;
  const transferredColor = safeColors?.transferred;
  const now = new Date();

  const start = new Date(now.getFullYear(), 0, 1); // Jan 1 of current year

  const startMonth = start.toLocaleString("default", { month: "short" });
  const currentMonth = now.toLocaleString("default", { month: "short" });
  const currentYear = now.getFullYear();
  const today = new Date().toISOString().split("T")[0];

  const label = `${startMonth} – ${currentMonth} ${currentYear}`;
  // useEffect(() => {
  //   fetchDashboard().then(setData).catch(() => setData(MOCK)).finally(() => setLoading(false));
  // }, []);

  // useEffect(() => {
  //   if (EmployeeID && CompanyID) {
  //     setLoading(true);      // ✅ show loader immediately
  //     // setData(null);

  //     setData(prev => prev);

  //     setRequestEmpId(EmployeeID); // ✅ track request
  //     dispatch(ProjectManagerDashboard({
  //       data: {
  //         EmployeeID,
  //         CompanyID,
  //         Type: "P",
  //       }
  //     }));
  //   }
  // }, [dispatch, EmployeeID, CompanyID]);

  useEffect(() => {
    if (EmployeeID && CompanyID) {
      const fetchData = async () => {
        setLoading(true);

        try {
          setRequestEmpId(EmployeeID);

          await dispatch(ProjectManagerDashboard({
            data: {
              EmployeeID,
              CompanyID,
              Type: "P",
            }
          }));

        } catch (err) {
          console.error(err);
        }
        // ❌ REMOVE finally from here
      };

      fetchData();
    }
  }, [dispatch, EmployeeID, CompanyID]);
  // useEffect(() => {
  //   if (ProjectManagerDashboardData?.status === true && ProjectManagerDashboardData?.EmployeeID === EmployeeID) {
  //     setData(ProjectManagerDashboardData.data); // ✅ DIRECT
  //     setLoading(false);
  //   }
  // }, [ProjectManagerDashboardData]);
  useEffect(() => {
    if (!ProjectManagerDashboardData) return;

    // ✅ THIS LINE IS THE REAL FIX
    if (ProjectManagerDashboardData.EmployeeID !== EmployeeID) return;

    if (ProjectManagerDashboardData.status === true) {
      setData(ProjectManagerDashboardData.data);
    }
    else {
      toast(ProjectManagerDashboardData.message, {
        icon: "ℹ️",
      });

      setData({
        taskSummaryCardData: [],
        statusDistribution: [],
        projectEffortData: {
          labels: [],
          projects: [],
          estimated: [],
          actual: [],
          drilldown: {}
        },
        projectList: [],
        personnelList: [],
        empTasksMap: {},
        actionItems: [],
        milestoneTimeline: [],
        taskStatusOverTime: {
          labels: [],
          completed: [],
          approved: [],
          todo: [],
          blocked: [],
          rejected: [],
          transferred: [],
          backlog: []
        }
      });
    }

    setLoading(false);

  }, [ProjectManagerDashboardData, EmployeeID, requestEmpId]);

  useEffect(() => {
    dispatch(EmergencyNotificationGet({ EmployeeID: EmployeeID, CompanyID: CompanyID, EventDate: today }));
  }, [dispatch, EmployeeID, CompanyID, today]);
  const theme = buildTheme(dark);


  const isEmpty =
    !loading &&
    (
      ProjectManagerDashboardData?.status === false ||
      (data?.projectList?.length === 0)
    );
  console.log("🚀 ~ ProjectManagerDashboardV1 ~ isEmpty:", isEmpty)
  if (isEmpty) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Topbar isCalendar={isCalendar} setIsCalendar={setIsCalendar} isEventCalendar={isEventCalendar} setIsEventCalendar={setIsEventCalendar} emergencyData={emergencyData} />

        <Box
          sx={{
            height: "70vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" fontWeight={600} gutterBottom>
            No Projects Found
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {ProjectManagerDashboardData?.message ||
              "No data available for this employee"}
          </Typography>
        </Box>
      </ThemeProvider>
    );
  }
  if (loading) return (
    <ThemeProvider theme={theme}><CssBaseline />
      {/* <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}> */}
      {/* <CircularProgress /> */}
      {/* <Typography color="text.secondary">Loading Project Manager Dashboard…</Typography> */}

      <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map(i => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Skeleton variant="rounded" height={120} />
            </Grid>
          ))}

          <Grid item xs={12} md={6}>
            <Skeleton variant="rounded" height={300} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Skeleton variant="rounded" height={300} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Skeleton variant="rounded" height={350} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Skeleton variant="rounded" height={350} />
          </Grid>

          <Grid item xs={12} md={4}>
            <Skeleton variant="rounded" height={350} />
          </Grid>
        </Grid>

      </Box>
    </ThemeProvider>
  );

  // const d = data;

  const d = data || {
    taskSummaryCardData: [],
    statusDistribution: [],
    projectEffortData: {
      labels: [],
      projects: [],
      estimated: [],
      actual: [],
      drilldown: {}
    },
    projectList: [],
    personnelList: [],
    empTasksMap: {}
  };
  const filteredProjs = (d.projectList || []).filter(p =>
    p.name.toLowerCase().includes(projSearch.toLowerCase()) ||
    p.id.toLowerCase().includes(projSearch.toLowerCase())
  );
  const pagedProjs = filteredProjs.slice(projOff, projOff + PP);
  // const filteredPers = (d.personnelList || []).filter(p => p.name.toLowerCase().includes(persSearch.toLowerCase()));

  const filteredPers = (d.personnelList || []).filter(p =>
    p.name.toLowerCase().includes(persSearch.toLowerCase())
  );

  const pagedPers = filteredPers.slice(persOff, persOff + PP_PERS);

  const filteredActions = d.actionItems || [];

  const pagedActions = filteredActions.slice(
    actionOff,
    actionOff + PP_ACTION
  );
  const kpiIcons = [
    // <CheckSquare key="0" sx={{ fontSize: 18, color: "#fff" }} />,
    <PendingActionsOutlinedIcon key="0" sx={{ fontSize: 18, color: "#fff" }} />,
    <Clock key="1" sx={{ fontSize: 18, color: "#fff" }} />,
    <CheckCircle key="2" sx={{ fontSize: 18, color: "#fff" }} />,
    <Briefcase key="3" sx={{ fontSize: 18, color: "#fff" }} />,
  ];

  return (

    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');`}</style> */}
      <style>
        {`
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');
`}
      </style>
      {/* <Topbar /> */}
      <Topbar isCalendar={isCalendar} setIsCalendar={setIsCalendar} isEventCalendar={isEventCalendar} setIsEventCalendar={setIsEventCalendar} emergencyData={emergencyData} />


      {isCalendar ? (
        <>
          {/* CALENDAR VIEW */}
          <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 14, fontWeight: 700 }}>Task Calendar</h3>
            </div>
            <div style={{ padding: '20px' }}>

              {/* ✅ SAME ROW: Legend (left) + Employee (right) */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between', // 🔥 pushes right content to end
                  marginBottom: 20,
                  paddingBottom: 15,
                  borderBottom: '1px solid rgba(0,0,0,0.07)'
                }}
              >
                {/* ✅ LEFT SIDE - LEGENDS */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 14, height: 14, backgroundColor: '#b9ecee', borderRadius: '3px' }} />
                    <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>Holiday</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 14, height: 14, backgroundColor: '#f3bac2', borderRadius: '3px' }} />
                    <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>WeekOff</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 14, height: 14, backgroundColor: '#ddcab1', borderRadius: '3px' }} />
                    <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>Leave</span>
                  </div>
                </div>

                {/* ✅ RIGHT SIDE - EMPLOYEE DROPDOWN */}
                {isManager === "1" && (
                  <div style={{ minWidth: 250 }}>
                    <Employeeautocomplete
                      name="empName"
                      label="Personnel"
                      id="empName"
                      value={selectedEmp}
                      onChange={(newValue) => {
                        if (newValue) {
                          setSelectedEmp(newValue);
                          const selectedEmpID = newValue.RecordID;

                          dispatch(
                            DashcalpostData({
                              Year: "2026",
                              Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                              EmployeeID: selectedEmpID,
                            })
                          );
                        } else {
                          setSelectedEmp(null);
                          dispatch(
                            DashcalpostData({
                              Year: "2026",
                              Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                              EmployeeID: EmployeeID,
                            })
                          );
                        }
                      }}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EmployeeID}","Any":"","CompId":${CompanyID}}}`}
                    />
                  </div>
                )}
              </div>

              {/* ✅ BELOW ROW */}
              <Datavisual1 />

            </div>
          </div>
        </>
      ) : isEventCalendar ? (
        <>
          {/* CALENDAR VIEW */}
          <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 14, fontWeight: 700 }}>Event Calendar</h3>
            </div>
            <div style={{ padding: '20px' }}>
              {/* ✅ BELOW ROW */}
              <EventCalender />

            </div>
          </div>
        </>

      ) : (
        <>
          <Box sx={{ p: { xs: "12px", sm: "16px 20px", md: "20px 24px" }, maxWidth: 1500, mx: "auto" }}>

            {/* Page header */}
            {/* <Box sx={{ mb: 2.25 }}> */}
            {/* <Typography variant="h6" fontWeight={600} letterSpacing={-0.3} fontSize={{ xs: 15, sm: 18 }}>Project Manager Dashboard</Typography> */}
            {/* <Typography variant="body2" color="text.secondary" mt={.25}>Overview Of All Active Projects And Tasks</Typography> */}
            {/* </Box> */}

            {/* ── KPI CARDS ── */}
            <Grid container spacing={{ xs: 1, sm: 1.5 }} sx={{ mb: 2.25 }}>
              {d.taskSummaryCardData.map((k, i) => (
                <Grid item xs={12} sm={6} lg={3} key={i}>
                  <Box
                    // onClick={() => setKpiPopup(k)} 
                    onClick={() => setKpiPopup({ ...k, index: i })}
                    sx={{
                      borderRadius: 3, p: "16px 18px", color: "#fff", position: "relative", overflow: "hidden",
                      cursor: "pointer", background: k.gradient, height: "100%",
                      transition: "transform .2s,box-shadow .2s",
                      "&:hover": { transform: "translateY(-3px)", boxShadow: "0 12px 32px rgba(0,0,0,.25)" },
                    }}>
                    <Box sx={{ position: "absolute", top: -30, right: -30, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,.08)" }} />
                    <Box sx={{ position: "absolute", top: 14, right: 14, width: 34, height: 34, borderRadius: "10px", background: "rgba(255,255,255,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      {kpiIcons[i]}
                    </Box>
                    <Typography fontSize={10} fontWeight={500} sx={{ opacity: .85, letterSpacing: .5, mb: .75 }}>{k.title}</Typography>
                    <Typography fontSize={{ xs: 26, sm: 32 }} fontWeight={600} lineHeight={1} mb={1.25} letterSpacing={-1} fontFamily="'Outfit',sans-serif">{k.count}</Typography>
                    <Stack direction="row" flexWrap="wrap" gap={.5}>
                      {k.breakdown.map((b, j) => (
                        <Box key={j} component="span" sx={{ fontSize: 10, fontWeight: 500, background: "rgba(255,255,255,.22)", borderRadius: "10px", px: 1, py: .25 }}>
                          {b.label} ({b.value})
                        </Box>
                      ))}
                    </Stack>
                    <Typography sx={{ position: "absolute", bottom: 6, right: 14, fontSize: 9, fontWeight: 500, opacity: .6 }}>Click to view ›</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* ── CHART ROW — equal height via alignItems="stretch" + display:"flex" on Grid items ── */}
            <Grid container spacing={{ xs: 1, sm: 1.75 }} sx={{ mb: 2.25 }} alignItems="stretch">

              <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                <Card elevation={6} sx={{ flex: 1 }}>
                  <CardHeader
                    // title={<Typography fontSize={13} fontWeight={700}>Task Status Distribution</Typography>}
                    title={<Typography fontSize={13} fontWeight={700}>{is002Subscription ? "Work Item Status" : "Task Status Distribution"}</Typography>}
                    action={<Chip label="Live" size="small" variant="outlined" color="primary" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0, "& .MuiCardHeader-action": { mt: .5 } }}
                  />
                  {/* CardContent uses the same fixed height for the chart body */}
                  <CardContent sx={{ pt: 1.5, "&:last-child": { pb: 2 } }}>
                    <DonutChart data={d.statusDistribution || []} />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1 }}>
                  <CardHeader
                    title={<Typography fontSize={13} fontWeight={700}>
                      {is003Subscription ? "Task Effort" : "Project Task Effort"}
                      {/* Project Task Effort */}

                    </Typography>}
                    action={<Chip label="Hours" size="small" variant="outlined" color="primary" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0, "& .MuiCardHeader-action": { mt: .5 } }}
                  />
                  <CardContent sx={{ pt: 1.5, "&:last-child": { pb: 2 } }}>
                    <EffortChart
                      data={d.projectEffortData || { labels: [], estimated: [], actual: [] }}
                      dark={dark}
                      onBarClick={setEffortModal}
                      colors={safeColors}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* ── MAIN GRID ── */}
            <Grid container spacing={{ xs: 1, sm: 1.75 }} alignItems="stretch">

              {/* Projects */}
              <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <CardHeader
                    title={<Typography fontSize={13} fontWeight={700}>
                      {is003Subscription ? "List Of Standard/Activities" : "List Of Projects"}
                      {/* List of Projects */}

                    </Typography>}
                    action={
                      <Stack direction="row" alignItems="center" gap={1}>
                        {/* <Typography variant="caption" color="text.secondary" sx={{ display: { xs: "none", sm: "block" } }}>Click row to view team</Typography> */}
                        <Typography variant="caption" color="text.secondary">{d.projectList?.length || 0} active</Typography>
                      </Stack>
                    }
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", "&:last-child": { pb: 2 } }}>
                    <TextField
                      size="small" placeholder={is003Subscription ? "Search Standard/Activities…" : "Search Projects…"} value={projSearch}
                      onChange={e => { setProjSearch(e.target.value); setProjOff(0); }}
                      InputProps={{

                        startAdornment: (
                          <InputAdornment
                            position="start">
                            <Search
                              sx={{ fontSize: 13 }} />
                          </InputAdornment>),
                        endAdornment: projSearch && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setProjSearch("");
                                setProjOff(0);
                              }}
                            >
                              <CloseIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                          </InputAdornment>
                        )


                      }}
                      sx={{ mb: 1.5 }} fullWidth
                    />
                    <TableContainer sx={{ flex: 1, overflowX: "auto" }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            {/* {["Project", "Status", "Progress", "Tasks"].map((h, i) => ( */}
                            {[is003Subscription ? "Standard/Activities" : "Projects", "Status", "Progress", "Tasks"].map((h, i) => (
                              <TableCell key={h} align={i === 4 ? "right" : "left"}>{h}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pagedProjs.map((p, i) => {
                            const sb = PROJ_STATUS[p.status] || PROJ_STATUS.active;
                            const pb = PROJ_BAR_COLOR[p.status] || "success";
                            return (
                              <TableRow key={i} hover
                                onClick={() => setProjModal(p)}
                                sx={{ cursor: "pointer", "&:hover td": { bgcolor: alpha(toDoColor, .04) } }}>
                                {/* <TableCell sx={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: "text.secondary" }}>{p.id}</TableCell> */}
                                <TableCell><Typography fontSize={12} title={p.name} fontWeight={500} noWrap sx={{ maxWidth: { xs: 80, sm: 130 } }}>{p.id} || {p.name}</Typography></TableCell>
                                <TableCell><Chip label={sb.label} size="small" color={sb.color} variant="outlined" sx={{ fontSize: 11 }} /></TableCell>
                                <TableCell>
                                  <Stack direction="row" alignItems="center" gap={.75}>
                                    <LinearProgress variant="determinate" value={p.prog} color={pb} sx={{ flex: 1, height: 5, borderRadius: 99, minWidth: 40, maxWidth: 70 }} />
                                    <Typography fontSize={11} fontFamily="'Outfit',sans-serif" color="text.secondary" noWrap>{p.prog}%</Typography>
                                  </Stack>
                                </TableCell>
                                <TableCell align="right"><Typography fontSize={13} fontWeight={600}>{p.tasks}</Typography></TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: "auto", pt: 1.25, borderTop: "1px solid", borderColor: "divider" }}>
                      <Typography variant="caption" color="text.secondary">
                        {projOff + 1}–{Math.min(projOff + PP, filteredProjs.length)} of {filteredProjs.length}
                      </Typography>
                      <Stack direction="row" gap={.5}>
                        <IconButton size="small" onClick={() => setProjOff(p => Math.max(0, p - PP))} disabled={projOff === 0}>
                          <ChevronLeft sx={{ fontSize: 14 }} />
                        </IconButton>
                        <IconButton size="small" onClick={() => setProjOff(p => Math.min(p + PP, Math.max(0, filteredProjs.length - PP)))} disabled={projOff + PP >= filteredProjs.length}>
                          <ChevronRight sx={{ fontSize: 14 }} />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              {/* Personnel */}
              <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1 }}>
                  <CardHeader
                    // title={<Typography fontSize={13} fontWeight={700}>Personnel Effort</Typography>}
                    title={<Typography fontSize={13} fontWeight={700}>{is002Subscription ? "Labour Cost & Effort" : "Personnel Effort"}</Typography>}
                    action={<Typography variant="caption" color="text.secondary">All Projects</Typography>}
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ "&:last-child": { pb: 2 } }}>
                    <Typography variant="caption" color="text.secondary" sx={{ mb: 1.5, display: "block" }}>{is002Subscription ? "Utilization & cost per worker" : "Estimated Vs Actual Hours + Utilization"}</Typography>
                    <TextField
                      size="small" placeholder={is002Subscription ? "Search Workers.." : "Search Person…"} value={persSearch}
                      // onChange={e => setPersSearch(e.target.value)}
                      onChange={e => {
                        setPersSearch(e.target.value);
                        setPersOff(0); // ✅ reset page
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"><Search sx={{ fontSize: 13 }} /></InputAdornment>
                        ),
                        endAdornment: persSearch && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setPersSearch("");
                                setPersOff(0);
                              }}
                            >
                              <CloseIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      sx={{ mb: 1.5 }} fullWidth
                    />
                    <Stack spacing={1.25}>
                      {/* {filteredPers.map((p, i) => { */}
                      {pagedPers.map((p, i) => {
                        const color = AVATAR_COLORS[i % AVATAR_COLORS.length];
                        return (
                          <Paper key={i} variant="outlined" onClick={() => setEmpModal({ person: p, color })} sx={{
                            display: "flex", alignItems: "center", gap: 1.25, p: 1, borderRadius: 2, cursor: "pointer",
                            transition: "background .15s,border-color .15s",
                            "&:hover": { bgcolor: alpha(theme.palette.primary.main, .05), borderColor: "primary.main" },
                          }}>
                            <Avatar sx={{ width: 36, height: 36, bgcolor: color, borderRadius: "10px", fontWeight: 700, fontSize: 11, flexShrink: 0 }}>{p.init}</Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography fontSize={12} fontWeight={600} noWrap>{p.name}</Typography>
                              <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">{p.id}</Typography>
                            </Box>
                            <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                              <Typography fontSize={12} fontWeight={600}>{p.cost}</Typography>
                              <Stack direction="row" alignItems="center" gap={.625} mt={.5}>
                                <Typography variant="caption" color="text.secondary" noWrap sx={{ display: { xs: "none", sm: "block" } }}>{p.util}% / {p.hrs}Hr</Typography>
                                <LinearProgress variant="determinate" value={Math.min(p.util * 3, 100)} color="success" sx={{ width: { xs: 40, sm: 60 }, height: 4, borderRadius: 99 }} />
                              </Stack>

                            </Box>
                            <ChevronRight sx={{ fontSize: 14, color: "text.disabled", flexShrink: 0 }} />
                          </Paper>
                        );
                      })}
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        mt: 1.5,
                        pt: 1.25,
                        borderTop: "1px solid",
                        borderColor: "divider"
                      }}
                    >
                      <Typography variant="caption" color="text.secondary">
                        {persOff + 1}–
                        {Math.min(persOff + PP_PERS, filteredPers.length)} of {filteredPers.length}
                      </Typography>

                      <Stack direction="row" gap={0.5}>
                        <IconButton
                          size="small"
                          onClick={() => setPersOff(p => Math.max(0, p - PP_PERS))}
                          disabled={persOff === 0}
                        >
                          <ChevronLeft sx={{ fontSize: 14 }} />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() =>
                            setPersOff(p =>
                              Math.min(p + PP_PERS, Math.max(0, filteredPers.length - PP_PERS))
                            )
                          }
                          disabled={persOff + PP_PERS >= filteredPers.length}
                        >
                          <ChevronRight sx={{ fontSize: 14 }} />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              {/* Trend */}
              {/* <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <CardHeader
                    title={
                      <Box>
                        <Typography fontSize={13} fontWeight={600}>Task Completion Trend</Typography>
                        <Typography variant="caption" color="text.secondary">Last 8 weeks · All projects</Typography>
                      </Box>
                    }
                    action={<Chip label="↑ 12%" size="small" color="success" variant="outlined" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", "&:last-child": { pb: 2 } }}>
                    <Box sx={{ flex: 1, position: "relative", minHeight: { xs: 200, md: 220 } }}>
                      <TrendChart data={d.taskTrend || { labels: [], actual: [], target: [] }} dark={dark} />
                    </Box>
                    <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 1.5 }}>
                      {[["#3b6ef8", "Completed"], ["rgba(100,100,100,.35)", "Target"]].map(([c, l]) => (
                        <Stack key={l} direction="row" alignItems="center" gap={.625}>
                          <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: c, flexShrink: 0 }} />
                          <Typography fontSize={11} color="text.secondary">{l}</Typography>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid> */}
              {/* Stacked bar Chart */}
              <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                {!is002Subscription ? (
                <Card sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <CardHeader
                    title={
                      <Box>
                        {/* <Typography fontSize={13} fontWeight={600}>Task Status Over Time</Typography> */}
                        <Typography fontSize={13} fontWeight={700}>Weekly Task Status</Typography>
                        <Typography variant="caption" color="text.secondary">Last {d.taskStatusOverTime?.labels?.length} weeks · {is003Subscription ? "All Standard/Activities" : "All projects"}</Typography>
                      </Box>
                    }
                    action={<Chip label="Weekly" size="small" color="primary" variant="outlined" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", "&:last-child": { pb: 2 } }}>
                    <Box sx={{ flex: 1, position: "relative", minHeight: { xs: 200, md: 220 } }}>
                      <StackedStatusChart data={d.taskStatusOverTime || { labels: [], actual: [], target: [] }} dark={dark} colors={overallColors} />
                    </Box>
                    <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 1.5 }}>
                      {[
                        // ["#059669", "Completed"],
                        [AVATAR_COLORS[2], "Completed"],
                        // ["#f59e0b", "In Progress"],
                        [AVATAR_COLORS[4], "Approved"],
                        [AVATAR_COLORS[0], "To Do"],
                        [AVATAR_COLORS[3], "Blocked"],
                        [AVATAR_COLORS[6], "Rejected"],
                        [AVATAR_COLORS[5], "Transferred"],
                        [AVATAR_COLORS[1], "Backlog"]].map(([c, l]) => (
                          <Stack key={l} direction="row" alignItems="center" gap={.625}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: c, flexShrink: 0 }} />
                            <Typography fontSize={11} color="text.secondary">{l}</Typography>
                          </Stack>
                        ))}
                    </Stack>
                  </CardContent>
                </Card>):(
                <Card sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <CardHeader
                    title={
                      <Box>
                        <Typography fontSize={13} fontWeight={700}>Budget Tracking</Typography>
                        <Typography variant="caption" color="text.secondary">Allotted vs Actual vs Overall Budget · Last {d.taskStatusOverTime?.labels?.length} weeks</Typography>
                      </Box>
                    }
                    action={<Chip label="Weekly" size="small" color="primary" variant="outlined" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", "&:last-child": { pb: 2 } }}>
                    <Box sx={{ flex: 1, position: "relative", minHeight: { xs: 200, md: 220 } }}>
                      <BudgetStatusChart data={d.taskStatusOverTime || { labels: [], actual: [], target: [] }} dark={dark} colors={overallColors} />
                    </Box>
                    <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 1.5 }}>
                      {[
                        [AVATAR_COLORS[2], "Actual Cost"],
                        [AVATAR_COLORS[0], "Alloted Cost"],
                        [AVATAR_COLORS[6], "Overall Budget"],
                        [AVATAR_COLORS[1], "Over Budget"]].map(([c, l]) => (
                          <Stack key={l} direction="row" alignItems="center" gap={.625}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: c, flexShrink: 0 }} />
                            <Typography fontSize={11} color="text.secondary">{l}</Typography>
                          </Stack>
                        ))}
                    </Stack>
                  </CardContent>
                </Card>)}
              </Grid>

              {/* Milestone */}
              <Grid item xs={12} md={8} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1 }}>
                  <CardHeader
                    title={
                      <Box>
                        <Typography fontSize={13} fontWeight={700}>Milestone Timeline</Typography>
                        <Typography variant="caption" color="text.secondary">{label} · {is003Subscription ? "All Standard/Activities" : "All Projects"}</Typography>
                        {/* <Typography variant="caption" color="text.secondary">Jan - June 2026 · {is003Subscription ? "All Standard/Activities" : "All Projects"}</Typography> */}
                      </Box>
                    }
                    action={<Chip label={`${d.milestoneTimeline?.length || 0} Projects`} size="small" variant="outlined" sx={{ fontSize: 10 }} />}
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ "&:last-child": { pb: 2 } }}>
                    <MilestoneTimeline data={d.milestoneTimeline || []} colors={overallColors} />
                  </CardContent>
                </Card>
              </Grid>

              {/* Action items */}
              <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                <Card sx={{ flex: 1 }}>
                  <CardHeader
                    title={
                      <Box>
                        <Typography fontSize={13} fontWeight={700}>Action Required</Typography>
                        <Typography variant="caption" color="text.secondary">{d.actionItems?.length || 0} items need attention</Typography>
                      </Box>
                    }
                    action={
                      <Chip label="Urgent" size="small" color="error" variant="outlined"
                        icon={<Box sx={{
                          width: 6, height: 6, borderRadius: "50%", bgcolor: "error.main", ml: 1,
                          animation: "pulse 1.5s infinite",
                          "@keyframes pulse": { "0%,100%": { opacity: 1, transform: "scale(1)" }, "50%": { opacity: .5, transform: "scale(1.4)" } }
                        }} />}
                        sx={{ fontSize: 10, padding: "0px 0px 0px 5px" }}
                      />
                    }
                    sx={{ pb: 0 }}
                  />
                  <CardContent sx={{ "&:last-child": { pb: 2 } }}>
                    <Stack spacing={1.25}>
                      {/* {(d.actionItems || []).map((a, i) => ( */}
                      {pagedActions.map((a, i) => (
                        <Paper key={i} variant="outlined" sx={{
                          display: "flex", borderRadius: 2, overflow: "hidden", cursor: "pointer",
                          "&:hover": { bgcolor: "action.hover" },
                        }}>
                          <Box sx={{ width: 4, flexShrink: 0, bgcolor: a.bar }} />
                          <Stack direction="row" alignItems="flex-start" gap={1.25} sx={{ p: "12px 14px", flex: 1 }}>
                            <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: a.dot, mt: .375, flexShrink: 0, boxShadow: `0 0 0 3px ${a.dot}26` }} />
                            <Box sx={{ flex: 1 }}>
                              <Typography fontSize={13} fontWeight={600} mb={.375}>{a.title}</Typography>
                              <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={.5}>
                                <Typography variant="caption" color="text.secondary" fontFamily="'Outfit',sans-serif">{a.meta}</Typography>
                                <Chip label={a.tag} size="small" color={a.tagColor || "default"} variant="outlined" sx={{ fontSize: 10, height: 20 }} />
                              </Stack>
                            </Box>
                          </Stack>
                        </Paper>
                      ))}
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        mt: 1.5,
                        pt: 1.25,
                        borderTop: "1px solid",
                        borderColor: "divider"
                      }}
                    >
                      <Typography variant="caption" color="text.secondary">
                        {actionOff + 1}–
                        {Math.min(actionOff + PP_ACTION, filteredActions.length)} of {filteredActions.length}
                      </Typography>

                      <Stack direction="row" gap={0.5}>
                        <IconButton
                          size="small"
                          onClick={() => setActionOff(p => Math.max(0, p - PP_ACTION))}
                          disabled={actionOff === 0}
                        >
                          <ChevronLeft sx={{ fontSize: 14 }} />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() =>
                            setActionOff(p =>
                              Math.min(p + PP_ACTION, Math.max(0, filteredActions.length - PP_ACTION))
                            )
                          }
                          disabled={actionOff + PP_ACTION >= filteredActions.length}
                        >
                          <ChevronRight sx={{ fontSize: 14 }} />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
          </Box>


          {kpiPopup && <KpiPopup kpi={kpiPopup} onClose={() => setKpiPopup(null)} />}
          {projModal && <ProjectModal project={projModal} projectEmployeeMap={d.projectEmployeeMap || {}} onClose={() => setProjModal(null)} colors={safeColors} />}
          {empModal && <EmpModal person={empModal.person} color={empModal.color} empTasksMap={d.empTasksMap || {}} onClose={() => setEmpModal(null)} />}
          {effortModal && <EffortModal projectCode={effortModal} effortData={d.projectEffortData} dark={dark} onClose={() => setEffortModal(null)} colors={safeColors} />}

        </>)}
    </ThemeProvider>
  );
}